/**
 * Dependencies
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dates } from '../../packages/dates';
import {
  HIDE_MODAL,
  MODAL_EPISODE_SELECT,
  AAF_MODAL_ERROR,
  MODAL_LANGUAGES,
  MODAL_LANGUAGES_LIVE,
  showModal
} from '../../actions/modal';
import { setResumeData } from '../../actions/resume';
import CodeToVal from '../../utils/CodeToVal';
import store from '../../store';
import { navigateFrom } from './../../actions/epg';
import { showNotification } from '../../actions/notification';
import ChannelSingleton from '../Epg/ChannelsSingleton';
import ChannelsSingleton from '../Epg/ChannelsSingleton';
import DeviceStorage from '../DeviceStorage/DeviceStorage';
import Utils from '../../utils/Utils';
import TvChannelUtil from '../../utils/TvChannelUtil';
/**
 * General
 */
import Metadata from '../../requests/apa/Metadata';
import PlayerStreamingUtils from '../../utils/PlayerStreamingUtils';
import * as playerConstant from '../../utils/playerConstants';
/**
 * Components
 */
import Button from '../Button/index';
import MiniEpg from '../Epg/MiniEpg';
/**
 * Assets
 */
import './player-ui.css';
import Asset from '../../requests/apa/Asset';
/**
 * Musica
 */
import {
  doFavorite,
  doToggleRepeat,
  doToggleShuffle,
  goToNextSong,
  goToPreviewSong
} from '../../actions/musica/player-controls-user';
import {
  finishPlaying,
  onPlayingRadio,
  startPlaying
} from '../../actions/musica/player-action-creators';
import {
  canGoToNextSong,
  checkListType,
  checkSongType,
  isPreviewSong
} from '../../actions/musica/player-shared-action-creators';
import AnalyticsDimensionSingleton from '../../components/Header/AnalyticsDimensionSingleton';
import Translator from '../../requests/apa/Translator';
/**
 * Player events
 */
import TrackerManager from '../../utils/TrackerManager';
import Device from '../../devices/device';
import { getLinksFromNavConfiguration } from '../Header';
import ModelDetection from '../../utils/ModelDetection';
import LayersControl from './../../utils/LayersControl';
import * as api from '../../requests/loader';
import Mini from '../../components/PersistentMiniEpg';
import {
  HideMiniObserver,
  HidePlayerControlsObserver,
  LetsPlayCatchup,
  ShowMiniObserver,
  ShowPlayerControlsObserver
} from '../PersistentMiniEpg/MiniObserver';
import settings from '../../devices/all/settings';
import EpgPersistence from '../../AAF/Nepg/EpgPersistence';
import * as constant from './../../AAFPlayer/constants';
import EventTimeshift from '../../AAF/Timeshift/EventTimeshift';
import MultipleLangLive from '../../AAF/LanguageLive/MultipleLangLive';
import ActionBar from '../../components/ActionBar/Index';
import EventEmitter from '../../utils/EventEmitter';
import FallbackUtil from '../Video/FallbackUtil';
import { NpvrUtil } from '../../AAF/Npvr/NpvrUtil';
import PlayerAudioSubtitleHelper from '../../AAFPlayer/helpers/PlayerAudioSubtitleHelper';
import { isAndroidDevice } from "../../AAFPersistenceManager/helpers/Utils";
import observer from '../../utils/MusicDetailPlayerObserver';
import SetLangsLive from '../EventOptions/components/SetLangsLive';
import { MODAL_INACTIVITY } from 'src/actions/modal';
import logger from 'src/utils/logger/logger';

const device_platform = Device.getDevice().getPlatform();
const config_remote_control = DeviceStorage.getItem('config_remote_control') !== 'simple';

const skip_seconds = Metadata.get('skip_seconds', 60);
const playerSettings = {
  slideTime: skip_seconds / 4,
  backwardTime: skip_seconds / 6, // 10 hacía atrás
  stepBackwardTime: skip_seconds / 4, // 15 hacía atrás
  fastBackwardTime: skip_seconds / 2, // 30 hacía atrás
  forwardTime: skip_seconds / 6, // 10 hacía adelante
  stepForwardTime: skip_seconds / 4, // 15 hacía adelante
  fastForwardTime: skip_seconds / 2, // 30 hacía adelante
  inactivityTime: skip_seconds / 3,

  // Timeshift
  backwardTime_timeshift: skip_seconds * 3, // 3 hacía atrás
  stepBackwardTime_timeshift: skip_seconds * 10, // 10 Mins hacía atrás
  forwardTime_timeshift: skip_seconds * 3, // 3 Mins hacía adelante
  stepForwardTime_timeshift: skip_seconds * 10, // 10 Mins hacía adelante
  slideTime_timeshift: skip_seconds * 3, // intervalos de 3 mins forward/backward

  types: {
    default: {
      buttons: ['back', 'replay', 'backward', 'play', 'forward', 'next', 'lang', 'seasons']
    },

    trailer: {
      buttons: ['back', 'replay', 'backward', 'play', 'forward', 'next']
    },

    catchup: {
      buttons: [
        'back',
        'record',
        'replay',
        'backward',
        'play',
        'forward',
        'next',
        'lang',
        'seasons'
      ]
    },

    serie: {
      buttons: ['back', 'replay', 'backward', 'play', 'forward', 'next', 'lang', 'seasons']
    },

    live: {
      buttons: [
        'back',
        'record',
        'stepBackward',
        'backward',
        'play',
        'forward',
        'stepForward',
        'lang',
        'epg'
      ]
    },

    musica: {
      buttons: [
        'back',
        'favorite',
        'previewSong',
        'backward',
        'play',
        'forward',
        'nextSong',
        'repeat',
        'shuffle'
      ]
    },

    radio: {
      buttons: ['back', 'play', 'favorite'] //remove favorite button from dvbc radio
    }
  }
};

const setSeekInterval = function(callback, intervalTime) {
  logger.debug('Playerinterval setSeekInterval');
  const seekInterval = {
    interval: intervalTime * 1000,
    callback: callback,
    stopped: false,
    timeout: null,
    initBucle: function() {
      //Do a stopped state
      if (seekInterval.stopped) {
        logger.debug(
          'Playerinterval setSeekInterval initBucle en stop (ready to track next seek)'
        );
        return;
      }
      logger.debug('Playerinterval setSeekInterval initBucle');
      let result;
      result = seekInterval.callback.call(seekInterval);
      logger.debug('Playerinterval setSeekInterval initBucle tiene result: ' + result);
      if (typeof result == 'number') {
        if (result === 0) {
          return;
        }
        seekInterval.interval = result;
      }
      // After do a seek, reinit loop (bucle method) to get next state: stopped state (above)
      seekInterval.bucle();
    },
    stop: function() {
      logger.debug('Playerinterval setSeekInterval stop');
      this.stopped = true;
      clearTimeout(this.timeout);
    },
    start: function() {
      logger.debug('Playerinterval setSeekInterval start');
      this.stopped = false;
      return this.bucle();
    },
    bucle: function() {
      logger.debug('Playerinterval setSeekInterval bucle ' + this.interval);
      this.timeout && clearTimeout(this.timeout);
      this.timeout = setTimeout(this.initBucle, this.interval);
      return this;
    }
  };

  return seekInterval.start();
};

const metadataReplayIcon = `
{
  "default": {
    "value": "#8065DF"
  },
  "colombia": {
    "value": "#E1251B"
  }
}
`;

const getBackgroundReplay = function() {
  const region = DeviceStorage.getItem('region');
  const metadata_replay_icon = getMedatataValue('replayIconBackground', metadataReplayIcon);
  if (region) {
    return metadata_replay_icon[region]
      ? (metadata_replay_icon[region].value)
      : (metadata_replay_icon['default'].value);
  } else {
    return metadata_replay_icon['default']
      ? (metadata_replay_icon['default'].value)
      : 0;
  }
};

const getMedatataValue = function(key, defaultValue) {
  const _metadataValue = JSON.parse(Metadata.get(key, defaultValue));
  return _metadataValue;
};

class PlayerControlsLegacy extends Component {
  static languageOptions = [];
  static isVisible = true;

  constructor(props) {
    super(props);
    this.serieData = null;
    this.timer = null;
    this.timerDelayChannelChange = null;
    this.isMoving = false;
    this.isVisible = false;
    this.isFocusButton = false;

    this.seekTime = 0;
    this.seekTotalTime = 0;
    this.seekInPause = 0;

    this.currentEvent = null;
    this.timeshiftAllowed = props.timeshiftAllowed;
    this.delayTimeshiftSeek = 1000; //ms;
    this.timerTimeshitDelayId = null;
    this.timeshift = null;

    this.isPlay = false;
    this.delayChannelChange = 1500;
    this.lastNumberPressed = '';
    this.maxLenNumberChannel = 4;
    this.buttonsType = '';

    this.currentTime = this.isLive() ? props.currentTimeshiftTime : 0;
    this.duration = this.isLive() ? this.timeshiftAllowed : props.duration;
    this.keys = Device.getDevice().getKeys();
    this.timePauseEventInterval = 1; // minutos

    this.codeToVal = new CodeToVal();
    this.settings = playerSettings;
    this.jsonLangs = [];
    this.disableTS = false;

    this.isInTrickMode = false;

    if (this.isLive()) {
      const autoHideMiniEpgSeconds = Metadata.get('mini_epg_auto_hide_seconds', 5);
      if (typeof autoHideMiniEpgSeconds === 'number') {
        this.settings.inactivityTime = autoHideMiniEpgSeconds;
      }
    }

    this.state = {
      playing: props.autoPlay,
      showControls: false,
      showBlueButton: true,
      timeshiftTime: 0,
      channelInfo: {},
      timeshiftEventInfo: null,
      actionBar: {
        isVisible: false,
        channel: '',
        title: ''
      },
      isSongFavorite: null,
    };

    this.hide = this.hide.bind(this);
    this.toggleControls = this.toggleControls.bind(this);

    this.canPlay = !!this.isLive();
    this.slide = this.slide.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onFocusMove = this.onFocusMove.bind(this);
    this.focus = this.focus.bind(this);
    this.keyPressHandler = this.keyPressHandler.bind(this);
    this.resetPlayerStatus = this.resetPlayerStatus.bind(this);

    this.play = this.play.bind(this);
    this.pause = this.pause.bind(this);
    this.seek = this.seek.bind(this);
    this.resetSeekInPause = this.resetSeekInPause.bind(this);

    this.previewSong = this.previewSong.bind(this);
    this.nextSong = this.nextSong.bind(this);
    this.onFinishSong = this.onFinishSong.bind(this);
    this.onPlayingSong = this.onPlayingSong.bind(this);
    this.onPlayingRadio = this.onPlayingRadio.bind(this);

    this.backward = this.backward.bind(this);
    this.stepBackward = this.stepBackward.bind(this);
    this.fastBackward = this.fastBackward.bind(this);
    this.forward = this.forward.bind(this);
    this.stepForward = this.stepForward.bind(this);
    this.fastForward = this.fastForward.bind(this);
    this.replay = this.replay.bind(this);
    this.back = this.back.bind(this);
    this.next = this.next.bind(this);
    this.record = this.record.bind(this);
    this.changeLang = this.changeLang.bind(this);
    this.handleEpisodeClick = this.handleEpisodeClick.bind(this);

    this.addListeners = this.addListeners.bind(this);
    this.removeButtonListener = this.removeButtonListener.bind(this);

    this.showLangModal = this.showLangModal.bind(this);
    this.updateSpriteSrc = this.updateSpriteSrc.bind(this);
    this.showSeasonsModal = this.showSeasonsModal.bind(this);
    this.showFullEpg = this.showFullEpg.bind(this);
    this.updateCurrentTime = this.updateCurrentTime.bind(this);
    this.updateDurationTime = this.updateDurationTime.bind(this);
    this.focusPlayButton = this.focusPlayButton.bind(this);
    this.focusBackwardButton = this.focusBackwardButton.bind(this);
    this.focusForwardButton = this.focusForwardButton.bind(this);
    this.focusSlider = this.focusSlider.bind(this);
    this.focusMiniEpg = this.focusMiniEpg.bind(this);
    this.handleChannelChange = this.handleChannelChange.bind(this);
    this.reopenMiniEpg = this.reopenMiniEpg.bind(this);

    this.onFavoriteSong = this.onFavoriteSong.bind(this);
    this.doRepeat = this.doRepeat.bind(this);
    this.doShuffle = this.doShuffle.bind(this);
    this.setChannelInfo = this.setChannelInfo.bind(this);
    this.enableButton = this.enableButton.bind(this);
    this.hasEpgErrorOnLive = this.hasEpgErrorOnLive.bind(this);
    this.saveEpgData = this.saveEpgData.bind(this);
    this.onSkipIntro = this.onSkipIntro.bind(this);
    this.enabledControlsTS = this.enabledControlsTS.bind(this);
    this.onPlayPausekeyPressHandler = this.onPlayPausekeyPressHandler.bind(this);
    this.showGuideFromActionBar = this.showGuideFromActionBar.bind(this);
    this.hideActionBar = this.hideActionBar.bind(this);
    this.handleBlueButton = this.handleBlueButton.bind(this);
    this.changeLangLive = this.changeLangLive.bind(this);
    this.getStreamType = this.getStreamType.bind(this);
    this.getCurrentTime = this.getCurrentTime.bind(this);

    this.watchCurrentTime = this.watchCurrentTime.bind(this);
    this.exitTrickMode = this.exitTrickMode.bind(this);

    this.persistentMiniIsVisible = this.persistentMiniIsVisible.bind(this);
    this.setMovementFocusRulesOnLimitButtons = this.setMovementFocusRulesOnLimitButtons.bind(this);

    this.toggleSongFavorite = this.toggleSongFavorite.bind(this);
    this.hideControls = this.hideControls.bind(this);
    this.resetSprites = this.resetSprites.bind(this);
    this.onPlayerStopMedia = this.onPlayerStopMedia.bind(this);
    this.enabledForThisContentStreamType = this.enabledForThisContentStreamType.bind(this);

    this.flagSkipIntro = false;
    this.introFinishTime = null;
    this.trackInfo = null;

    const that = this;
    this.seekBarInterval = setSeekInterval(function() {
      if (that.seekTotalTime >= 0 && that.isMoving) {
        logger.debug('[PlayerControls] interval seek', that.seekTotalTime);
        //Send stats related to seek (i.e. sumologic)
        that.sendFowardRewindSeek();
        that.seek(that.seekTotalTime);
        that.seekTotalTime = 0;
        that.seekTime = 0;
        that.isMoving = false;
        that.setTimer();
      }
      logger.debug('[PlayerControls] interval before stop after set seek ');
      this.stop();
    }, 2);

    this.playerStreamingUtils = new PlayerStreamingUtils();
    this.recordingsEnabled = this.playerStreamingUtils.getButtonRecord('npvr_button_record');
    this.metricSend = null;

    // Envio de información hacia el dashboard.
    this.player = Device.getDevice().getPlayer();
    this.onHideListeners = [];
    this.initSpriteConfig();
    this.currentLangChapter = [];
    this.hasSkipIntro = false;
    // Para guardar referencias a los listeners en los botones y después poder removerlos
    this.buttonsListeners = {};
    this.proporcion = 0;

    this.waitForSeconds = false;

    this.onSeekStartOver = this.onSeekStartOver.bind(this);

    // When playing speed changes...
    this.onRateChange = this.onRateChange.bind(this);

    this.pendingLiveOnPause = null;
    this.pendingStartOverOnPause = null;

    this.switchingBetweenEventTimeshift = false;
    this.forceStopAutoHide = false;
    this.liveWasPause = false;
    this.letsPlayCatchup = false;
  }

  initSpriteConfig = () => {
    this.spriteShown = 'hidden';
    this.imageSprite = new Image();
    this.imageSprite.crossOrigin = 'Anonymous';
    this.imageSpriteURL = '';
    this.imageSpriteURLnew = '';
    this.shouldSpriteShow = false;
  };

  /**
   *
   * @param {*} seekWasTo seconds, the seek we did to
   */
  onSeekStartOver(seekWasTo) {
    this.switchingBetweenEventTimeshift = false;
    logger.debug('PAU> function onSeekStartOver ' + this.switchingBetweenEventTimeshift);
    // hacer la pausa del start over
    //this.pendingLiveOnPause = this.getCurrentTime();
    //this.props.pause();
  }

  /**
   * params = {speed: number, direction: FORWARD|BACKWARD}
   * @param speed
   * @param direction
   * @param frompause
   */
  onRateChange(speed, direction, frompause) {
    if( this.props.streamContentType() === constant.AAF_CONTENT_IS_VOD
      || this.props.streamContentType() === constant.AAF_CONTENT_IS_AUDIO
      || this.props.streamContentType() === constant.AAF_CONTENT_IS_RADIO ){

      // This fix is because when reproduce a vod and press pause button,

      // this event fired and change the state isPlaying to true and before was false and produce no toggle play/pause button issue

      return;

    }
    speed = Math.abs(speed);
    speed = speed + '';
    const trickBackward = document.getElementById('trickmode_backward');
    const trickForward = document.getElementById('trickmode_forward');
    if (!trickBackward || !trickForward) return;

    if (speed != 0) {
      this.isInTrickMode = true;
      if (direction === 'FORWARD') {
        trickBackward.innerText = '';
        trickForward.innerText = 'x' + speed;
        this.setState({ playing: false }, this.focusForwardButton);
      }
      if (direction === 'BACKWARD') {
        this.isInTrickMode = true;
        trickForward.innerText = '';
        trickBackward.innerText = 'x' + speed;
        this.setState({ playing: false }, this.focusBackwardButton);
      }
    } else {
      this.isInTrickMode = false;
      trickBackward.innerText = '';
      trickForward.innerText = '';

      let playing = true;
      if (
        this.props.streamContentType() === constant.AAF_CONTENT_IS_NPVR ||
        this.props.streamContentType() === constant.AAF_CONTENT_IS_CATCHUP
      ) {
        playing = frompause !== true;
      }
      this.setState({ playing }, this.focusPlayButton);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      (nextProps.checkStatusMiniEPG !== this.props.checkStatusMiniEPG &&
        nextProps.checkStatusMiniEPG === false) ||
      (nextProps.checkStatusEPG && !this.props.checkStatusMiniEpg)
    ) {
      if (this.isPlay) {
        this.hide();
      }
    }
    this.reopenMiniEpg(nextProps);
  }

  reopenMiniEpg(nextProps) {
    if (nextProps.checkStatusEPG !== this.props.checkStatusEPG && !nextProps.checkStatusEPG) {
      this.isVisible = !(
        EpgPersistence.isEnabled() &&
        (Utils.isFullEpgPersistanceOpen() || Utils.isFullEpgMosaicOpen())
      );
    }
  }

  // skipIntro
  doFocusableSkipIntro() {
    this.focus('.focusable-skip');
  }

  hideSkipIntro() {
    Utils.hideSkipIntro();
  }

  showSkipIntro() {
    let skipIntroElement = document.getElementsByClassName('player-ui-container-skip')[0];
    if (skipIntroElement) {
      // this.toggleControls();
      skipIntroElement.classList.add('show-skip-intro');
      this.doFocusableSkipIntro();
    }
  }

  skipIntroControl() {
    // Se ejecuta cada vez que se recibe componentDidUpdate
    let langsChapter = PlayerControlsLegacy.languageOptions;

    if (langsChapter.length > 0 && this.props.type === 'vod' && !this.isTrailer()) {
      const currentLang = DeviceStorage.getItem('default_lang');
      this.hasSkipIntro =
        langsChapter[0].intro_finish_time !== null &&
        langsChapter[0].intro_start_time !== null;

      if (this.hasSkipIntro) {
        this.currentLangChapter = langsChapter.filter(
          lang => lang.option_id === currentLang
        );
        this.introFinishTime =
          this.currentLangChapter[0] && this.currentLangChapter[0].intro_finish_time;
        this.introStartTime =
          this.currentLangChapter[0] && this.currentLangChapter[0].intro_start_time;
      } else {
        let skipIntroElement = document.getElementsByClassName(
          'player-ui-container-skip'
        )[0];

        if (this.flagSkipIntro && skipIntroElement) {
          this.hideSkipIntro();
        }
      }
    }
  }

  handleSkipIntro() {
    if (this.hasSkipIntro) {
      const curTime = this.getCurrentTime();

      if (
        curTime >= this.introStartTime &&
        curTime <= this.introFinishTime &&
        this.flagSkipIntro === false
      ) {
        this.flagSkipIntro = true;
        this.showSkipIntro();
      } else if (
        this.flagSkipIntro === true &&
        (curTime > this.introFinishTime || curTime < this.introStartTime)
      ) {
        this.flagSkipIntro = false;
        this.hideSkipIntro();
      }
    }
  }

  onSkipIntro(e) {
    e.preventDefault();
    e.stopPropagation();

    let curTime = parseInt(this.getCurrentTime(), 10);
    this.hideSkipIntro();
    if (!this.state.playing) this.play();
    const seekTime = parseInt(this.introFinishTime, 10);
    this.setOperatorsSeek({ curTime, seekTime });
    this.doSeek(seekTime, curTime);
    this.updateCurrentTimeUI(seekTime);
    this.updateSprite(seekTime);
    this.hideSprites();

    // hideControlsAfterSkip
    const className = this.refs.container.className;
    this.refs.container.className =
      className.indexOf('hide-controls') === -1 ? `${className} hide-controls` : className;
  }

  onCanPlay() {
    logger.debug('[PlayerControlsLegacy.onCanPlay]');
    this.canPlay = true;
    this.isPlay = true;
    this.setState({ playing: true });
    this.isInTrickMode = false;
  }

  getCurrentTime() {
    const currentTime = this.currentTime < 0 ? 0 : this.currentTime;

    //FIX para https://dlatvarg.atlassian.net/browse/STV-8748
    //Oculta el player si  no hay tiempo calculado, en el cambio de idioma.
    const streamContentType = this.props.streamContentType();
    if (streamContentType === constant.AAF_CONTENT_IS_VOD && currentTime === 0) {
      this.hide();
    }

    return currentTime;
  }

  setCurrentTime(time) {
    this.currentTime = time;
    this.watchCurrentTime(time);
  }

  watchCurrentTime(currentTime) {
    const streamContentType = this.props.streamContentType();
    switch (streamContentType) {
      case constant.AAF_CONTENT_IS_STARTOVER:
      case constant.AAF_CONTENT_IS_NPVR:
      case constant.AAF_CONTENT_IS_CATCHUP:
        // Está en trickmode?
        if (this.isInTrickMode && currentTime <= 1) {
          // break trickmode
          this.exitTrickMode();
        }
        break;
      default:
        break;
    }
  }

  setDuration(time) {
    this.duration = time;
    if (this.props.type === playerConstant.AUDIO && store.dispatch(isPreviewSong())) {
      this.duration = '30';
    }
  }

  getDuration() {
    // FIXME TIMESHIFT es necesario verificar si es live? creo que no, porque player siempre
    // regresa un null en event cuando el contenido a reproducir no tiene timeshift
    if (this.useTimeshiftEvent()) {
      //console.log('PAU> PlayerControls > getDuration > this.state.timeshiftEventInfo NO es null > duración: ' + (this.state.timeshiftEventInfo.event.date_end - this.state.timeshiftEventInfo.event.date_begin) + ' segundos');
      return (
        this.state.timeshiftEventInfo.event.date_end -
        this.state.timeshiftEventInfo.event.date_begin
      );
    } else {
      //console.log('PAU> PlayerControls > getDuration > this.state.timeshiftEventInfo SI es null > duración: ' + this.duration + ' segundos');
      return this.isLive() && this.hasTimeshift() ? this.timeshiftAllowed : this.duration;
    }
  }

  /**
   * Calculate current time as percent of duration
   * @param currentTime
   * @returns {number}
   */
  getPercentProgress(currentTime) {
    //console.log('PAU4> PlayerControlsLegacy.getPercentProgress currentTime: ' + currentTime);
    //console.log('PAU4> PlayerControlsLegacy.getPercentProgress  this.getDuration(): ' +  this.getDuration());

    const percent = currentTime > 0 ? (currentTime * 100) / this.getDuration() : 0;
    //console.log('PAU4> PlayerControlsLegacy.getPercentProgress  percent: ' +  percent);
    return percent <= 100 ? percent : 100;
  }

  /**
   * Set current time string in DOM without change state an re render
   * @param currentTime
   */
  updateCurrentTime(currentTime) {
    this.handleSkipIntro();

    if (!this.isLive()) {
      this.setCurrentTime(currentTime);
      if (!this.isMoving) {
        if (
          this.props.type === playerConstant.AUDIO &&
          this.duration === '30' &&
          currentTime >= this.duration
        ) {
          if(!this.endingSong){
            this.endingSong = true;
            this.onFinishSong();
            this.pause();
          }
        } else {
          this.endingSong = false;
          this.updateCurrentTimeUI(currentTime);
        }
      }
    } else {
      if (this.useTimeshiftEvent()) {
        this.setCurrentTime(currentTime);
        if (!this.isMoving) {
          this.updateCurrentTimeUI(currentTime);
        }
      }
    }
  }

  getAbsoluteElementPosition(idOfElement) {
    let element = document.getElementById(idOfElement);

    if (!element) return { top: 0, left: 0 };

    let y = 0;
    let x = 0;
    while (element.offsetParent) {
      x += element.offsetLeft;
      y += element.offsetTop;
      element = element.offsetParent;
    }
    return { top: y, left: x };
  }

  areSpritesSupportedOnThisDevice() {
    const modelDetection = ModelDetection.getDeviceDescription();
    const modelDevice = modelDetection.modelDevice;
    const platform = modelDetection.platform;
    let result;

    const device = modelDevice === null ? platform : modelDevice;
    logger.debug('[playerControls][deviceDescription]', modelDetection);

    switch (device) {
      case 'ps4':
      case 'hisense':
      case 'samsung-hybrid':
      case 'sony-bravia':
        result = false;
        break;
      default:
        result = true;
        break;
    }
    return result;
  }

  canShowSprites() {
    let result = false;

    if (this.imageSprite.src && this.imageSpriteURL !== '' && this.refs && this.refs.sprite && this.refs.sprite.getContext) {
      let ctx = this.refs.sprite.getContext('2d');
      const frame_width = 200;
      const frame_height = 113;
      const maxRow = 10;
      let fraccion = 1 / 8;
      let count_fraccionado = 0;

      ctx.canvas.height = frame_height;
      ctx.canvas.width = frame_width;
      try {
        //this.isPixelEmpty(ctx.getImageData(0, 0, 1 , 1));
        if (this.proporcion == 0) {
          ctx.drawImage(
            this.imageSprite,
            frame_width * (maxRow - 1),
            0,
            frame_width,
            frame_height,
            0,
            0,
            frame_width,
            frame_height
          );
          this.proporcion = 1;
          while (
            this.isPixelEmpty(ctx.getImageData(190, 0, 1, 1)) &&
            this.proporcion >= 0
            ) {
            count_fraccionado++;
            this.proporcion = 1 - count_fraccionado * fraccion;
            logger.debug('CANVAS PROPORCION: ', this.proporcion);
            ctx.drawImage(
              this.imageSprite,
              frame_width * this.proporcion * (maxRow - 1),
              0,
              frame_width * this.proporcion,
              frame_height * this.proporcion,
              0,
              0,
              frame_width,
              frame_height
            );
          }
        }
        if (this.proporcion > 1 - 3 * fraccion) {
          //Solo se redujo a lo más en 2/8 la resolución
          result = true;
        }
      } catch (error) {
        logger.error(
          `Images are not found in route:"${this.imageSprite.src}" ... ${error}`
        );
      }
    }
    return result;
  }

  updateSprite(currentTime) {
    if (this.spriteShown === 'visible' && this.imageSprite.src) {
      let ctx = this.refs.sprite.getContext('2d');
      currentTime = currentTime / 10;
      const frame_width = 200;
      const frame_height = 113;
      const maxRow = 10;
      let rowLength = frame_width;
      let row = Math.round(parseInt(currentTime / 10));
      let column = Math.round(parseInt((currentTime % rowLength) % 10));
      logger.debug('SPRITE ROW:' + row);
      logger.debug('SPRITE ROW_LENGHT:' + rowLength);
      logger.debug('SPRITE CurrentTime:' + currentTime);
      logger.debug('SPRITE COLUMN:' + column);
      logger.debug('SPRITE height:' + this.imageSprite.height);
      logger.debug('SPRITE width:' + this.imageSprite.width);
      logger.debug('CANVAS height:' + this.canvasHeight);
      ctx.canvas.height = frame_height;
      ctx.canvas.width = frame_width;
      try {
        if (this.proporcion > 1 - 3 / 8) {
          //Solo se redujo a lo más en 2/8 la resolución
          ctx.drawImage(
            this.imageSprite,
            frame_width * this.proporcion * column,
            frame_height * this.proporcion * row,
            frame_width * this.proporcion,
            frame_height * this.proporcion,
            0,
            0,
            frame_width,
            frame_height
          );
        }
      } catch (error) {
        logger.error(
          `Images are not found in route:"${this.imageSprite.src}" ... ${error}`
        );
      }
    }
  }

  isPixelEmpty(imgData) {
    const red = imgData.data[0];
    const green = imgData.data[1];
    const blue = imgData.data[2];
    const alpha = imgData.data[3];
    logger.debug('COLORS:' + red + ' ' + green + ' ' + blue + ' ' + alpha);

    return red === 0 && green === 0 && blue === 0 && alpha === 0;
  }

  updateCurrentTimeUI(currentTime) {
    if (this.refs.currentTime) {
      if (this.isLive()) {
        let hasTshift = this.hasTimeshift();
        let ct = this.getCurrentTime();
        let dur = this.getDuration();

        const currentTimeUI =
          this.isLive() && hasTshift && this.state.timeshiftTime !== 0
            ? this.state.timeshiftTime
            : ct;
        let diff = dur - currentTimeUI;

        let label = '';
        let currentTimeClassName = null;

        if (this.useTimeshiftEvent()) {
          if (this.isLiveWithTimeshiftEvent()) {
            label = 'EN VIVO';
            currentTimeClassName = 'player-ui-current-time-timeshift-live';

            this.addRefCss(this.refs.progressBar, 'player-ui-progress-bar-time-tick');
            this.removeTimeshiftStyleBar('player-ui-current-time-timeshift-catchup');
            this.removeRefCss(this.refs.progressBar, 'player-ui-progress-bar-catchup');

            this.addRefCss(this.refs.slider, 'player-ui-progress-bar-ball');
            this.removeRefCss(this.refs.slider, 'player-ui-progress-bar-ball-catchup');

            this.addRefCss(this.refs.currentTime, 'player-ui-current-time');
            this.removeRefCss(this.refs.currentTime, 'player-ui-current-time-catchup');

            //Estilo de nueva barra para catchup
            if (this.refs && this.refs.progressBarOpacity) {
              this.removeRefCss(
                this.refs.progressBarOpacity,
                'player-ui-progress-bar-opacity-enabled'
              );
              this.addRefCss(
                this.refs.progressBarOpacity,
                'player-ui-progress-bar-opacity-disabled'
              );
            }

            if (this.refs && this.refs.horizontOne) {
              this.removeRefCss(this.refs.horizontOne, 'horizont-one-catchup');
              this.removeRefCss(this.refs.horizontTwo, 'horizont-two-catchup');
            }
          }
          if (this.isStartOverWithTimeshiftEvent()) {
            //let img_src = Asset.get('player_controls_replay_icon');
            //label = `<img class="player-ui-current-time-timeshift-catchup-icon" src="${img_src}" >`;
            // playerProgressBar

            this.addRefCss(this.refs.duration, 'player-ui-duration-startover');
            this.removeRefCss(this.refs.duration, 'player-ui-duration');

            label = this.getCurrentTimeAsString(currentTimeUI);

            currentTimeClassName = 'player-ui-current-time-timeshift-catchup';
            this.removeTimeshiftStyleBar('player-ui-current-time-timeshift-live');

            this.addRefCss(this.refs.progressBar, 'player-ui-progress-bar-catchup');
            this.removeRefCss(
              this.refs.progressBar,
              'player-ui-progress-bar-time-tick'
            );

            this.removeRefCss(this.refs.slider, 'player-ui-progress-bar-ball');
            this.addRefCss(this.refs.slider, 'player-ui-progress-bar-ball-catchup');

            this.addRefCss(this.refs.currentTime, 'player-ui-current-time-catchup');
            this.removeRefCss(this.refs.currentTime, 'player-ui-current-time');
            if (this.refs && this.refs.progressBarOpacity) {
              this.addRefCss(
                this.refs.progressBarOpacity,
                'player-ui-progress-bar-opacity-enabled'
              );
              this.removeRefCss(
                this.refs.progressBarOpacity,
                'player-ui-progress-bar-opacity-disabled'
              );
              let limit_forward =
                this.state.timeshiftEventInfo.event.date_end -
                Utils.nowAsTimestampSeconds();
              let dur_limit_forward =
                this.state.timeshiftEventInfo.event.date_end -
                this.state.timeshiftEventInfo.event.date_begin -
                limit_forward;
              const percent = this.getPercentProgress(dur_limit_forward);
              this.refs.progressBarOpacity.style.width = `${percent}%`;
            }
            if (this.refs && this.refs.horizontOne) {
              this.addRefCss(this.refs.horizontOne, 'horizont-one-catchup');
              this.addRefCss(this.refs.horizontTwo, 'horizont-two-catchup');
            }
          }
        } else {
          label =
            !hasTshift || diff <= 0
              ? 'EN DIRECTO'
              : `-${Utils.parseSecondsToHours(diff)}`;
        }

        if (currentTimeClassName) {
          this.addTimeshiftStyleBar(currentTimeClassName);
        } else {
          this.removeRefCss(this.refs.progressBar, 'player-ui-progress-bar-catchup');
          this.addRefCss(this.refs.progressBar, 'player-ui-progress-bar-time-tick');

          this.removeTimeshiftStyleBar('player-ui-current-time-timeshift-catchup');
          this.removeTimeshiftStyleBar('player-ui-current-time-timeshift-live');

          this.removeRefCss(this.refs.slider, 'player-ui-progress-bar-ball-catchup');
          this.addRefCss(this.refs.slider, 'player-ui-progress-bar-ball');

          this.addRefCss(this.refs.currentTime, 'player-ui-current-time');
          this.removeRefCss(this.refs.currentTime, 'player-ui-current-time-catchup');

          //Ocultando la barra de time falsa
          if (this.refs && this.refs.progressBarOpacity) {
            this.removeRefCss(
              this.refs.progressBarOpacity,
              'player-ui-progress-bar-opacity-enabled'
            );
            this.addRefCss(
              this.refs.progressBarOpacity,
              'player-ui-progress-bar-opacity-disabled'
            );
          }

          if (this.refs && this.refs.progressBarOpacity) {
            this.removeRefCss(this.refs.horizontOne, 'horizont-one-catchup');
            this.removeRefCss(this.refs.horizontTwo, 'horizont-two-catchup');
          }
        }

        this.refs.currentTime.innerHTML = label;
      } else {
        this.refs.currentTime.innerHTML = this.getCurrentTimeAsString(currentTime);
        this.refs.currentTimeSprite.innerHTML = this.getCurrentTimeAsString(currentTime);

        /*
         if(this.refs.currentTime.classList.indexOf('player-ui-current-time-timeshift-live') !== -1) {
         this.refs.currTime.classList.remove('player-ui-current-time-timeshift-live');
         }
         if(this.refs.currTime.classList.indexOf('player-ui-current-time-timeshift-catchup') !== -1) {
         this.refs.currTime.classList.remove('player-ui-current-time-timeshift-catchup');
         }
         */

        this.addRefCss(this.refs.duration, 'player-ui-duration');
        this.removeRefCss(this.refs.duration, 'player-ui-duration-startover');

        this.addRefCss(this.refs.progressBar, 'player-ui-progress-bar-time-tick');
        this.removeRefCss(this.refs.progressBar, 'player-ui-progress-bar-catchup');

        this.addRefCss(this.refs.slider, 'player-ui-progress-bar-ball');
        this.removeRefCss(this.refs.slider, 'player-ui-progress-bar-ball-catchup');

        this.addRefCss(this.refs.currentTime, 'player-ui-current-time');
        this.removeRefCss(this.refs.currentTime, 'player-ui-current-time-catchup');

        //Ocultando la barra de time falsa
        if (this.refs && this.refs.progressBarOpacity) {
          this.removeRefCss(
            this.refs.progressBarOpacity,
            'player-ui-progress-bar-opacity-enabled'
          );
          this.addRefCss(
            this.refs.progressBarOpacity,
            'player-ui-progress-bar-opacity-disabled'
          );
        }
        if (this.refs && this.refs.horizontOne) {
          this.removeRefCss(this.refs.horizontOne, 'horizont-one-catchup');
          this.removeRefCss(this.refs.horizontTwo, 'horizont-two-catchup');
        }
      }
    }
    if (this.refs.progressBar) {
      let currentTimePg;
      // Nueva experiencia timeshift
      if (this.useTimeshiftEvent()) {
        // console.log('PAU4> ======================== currentTime: ', currentTime);
        // console.log('PAU4> this.state.timeshiftTime: ', this.state.timeshiftTime);
        // Force to zero when user go back to zero in progress bar
        if (this.isLiveWithTimeshiftEvent()) {
          document.getElementById('startovericon').style.display = 'none';
          if (this.waitForSeconds && this.state.timeshiftTime === 0) {
            //console.log('PAU> function currentTime === 0 && this.waitForSeconds: ', this.waitForSeconds);
            currentTimePg = 0;
          } else if (currentTime === 0) {
            currentTimePg = 0;
          } else if (this.state.timeshiftTime !== 0) {
            //console.log('PAU> function this.state.timeshiftTime: ', this.state.timeshiftTime);
            currentTimePg = this.state.timeshiftTime;
          } else {
            //console.log('PAU> function PLAYER CONTROLS LIVE** set currentTimePg a currentTime: ' + currentTime);
            currentTimePg = currentTime;
          }
          //console.log('PAU> function isLiveWithTimeshiftEvent currentTimePg: ', currentTimePg);
        }

        if (this.isStartOverWithTimeshiftEvent()) {
          document.getElementById('startovericon').style.display = '';
          if (this.waitForSeconds && this.state.timeshiftTime === 0) {
            //console.log('PAU4> currentTime === 0 && this.waitForSeconds: ', this.waitForSeconds);
            //console.log('PAU4> set 1 currentTimePg a 0');
            currentTimePg = 0;
          } else if (currentTime === 0) {
            currentTimePg = 0;
            //console.log('PAU4> set 2 currentTimePg a 0');
          } else if (this.state.timeshiftTime !== 0) {
            //console.log('PAU4> this.state.timeshiftTime: ', this.state.timeshiftTime);
            currentTimePg = this.state.timeshiftTime;
            //console.log('PAU4> set currentTimePg a state.timeshiftTime: ' + currentTimePg + ', Waiting for seconds = ' + (this.waitForSeconds ? 'TRUE' : 'FALSE'));

            //console.log('PAU4> percent: ' + percent + '%');
          } else {
            currentTimePg = currentTime;
            //console.log('PAU4> PLAYER CONTROLS STARTOVER* set currentTimePg a currentTime: ' + currentTime);
          }
        }
      }
      // Vieja experiencia timeshift
      else {
        document.getElementById('startovericon').style.display = 'none';
        currentTimePg =
          this.isLive() && this.hasTimeshift() && this.state.timeshiftTime !== 0
            ? this.state.timeshiftTime
            : currentTime;
      }

      const percent =
      (this.isLive() && !this.hasTimeshift()) || this.props.type === playerConstant.RADIO
          ? 100
          : this.getPercentProgress(currentTimePg);
      //console.log('PAU> function percent: ' + percent + '%' + ', this.switchingBetweenEventTimeshift: ' + this.switchingBetweenEventTimeshift);
      this.refs.progressBar.style.width = `${percent}%`;
      const position = this.getAbsoluteElementPosition('player-ui-progress-bar-ball');
      this.refs.sprite.style.left = `${position.left -
      (this.refs.sprite.offsetWidth / 2 - this.refs.slider.offsetWidth / 2)}px`;
      this.refs.sprite.style.top = `${position.top - 150}px`;
      this.refs.sprite.style.visibility = `${this.spriteShown}`;
      this.refs.currentTimeSprite.style.visibility = `${this.spriteShown}`;

      this.refs.currentTimeSprite.style.left = `${position.left -
      (this.refs.currentTimeSprite.offsetWidth / 2 -
        this.refs.slider.offsetWidth / 2)}px`;
      this.refs.currentTimeSprite.style.top = `${position.top - 60}px`;
    }
  }

  useTimeshiftEvent() {
    return (
      this.hasTimeshift() &&
      this.state.timeshiftEventInfo &&
      this.state.timeshiftEventInfo.event
    );
  }

  isLiveWithTimeshiftEvent() {
    let ret = false;
    if (this.useTimeshiftEvent()) {
      if (this.state.timeshiftEventInfo && this.state.timeshiftEventInfo.playerOptions) {
        ret =
          this.state.timeshiftEventInfo.playerOptions.currentContentType ===
          constant.AAF_CONTENT_IS_TV;
      }
    }

    return ret;
  }

  isStartOverWithTimeshiftEvent() {
    let ret = false;
    if (this.useTimeshiftEvent()) {
      if (this.state.timeshiftEventInfo && this.state.timeshiftEventInfo.playerOptions) {
        ret =
          this.state.timeshiftEventInfo.playerOptions.currentContentType ===
          constant.AAF_CONTENT_IS_STARTOVER;
      }
    }

    return ret;
  }

  addRefCss(ref, classss) {
    if (ref && ref.classList) {
      if (!ref.classList.contains(classss)) {
        ref.classList.add(classss);
      }
    }
  }

  removeRefCss(ref, classss) {
    if (ref && ref.classList) {
      if (ref.classList.contains(classss)) {
        ref.classList.remove(classss);
      }
    }
  }

  addTimeshiftStyleBar(currentTimeClassName) {
    if (this.refs.currentTime) {
      this.addRefCss(this.refs.currentTime, currentTimeClassName);
    }
  }

  removeTimeshiftStyleBar(currentTimeClassName) {
    if (this.refs.currentTime) {
      this.removeRefCss(this.refs.currentTime, currentTimeClassName);
    }
  }

  updateDurationTime(duration) {
    this.setDuration(duration);

    let dura = '';

    if (this.refs.duration) {
      const streamContentType = this.props.streamContentType();
      if (!this.isLive()) {
        if (streamContentType === constant.AAF_CONTENT_IS_CATCHUP) {
          let endTime = null;
          const resParams = this.props.playingResolvedParams();
          if(resParams && resParams.playerMedia) {
            if(resParams.playerMedia.entry) {
              endTime = resParams.playerMedia.entry.endTime;
              if(endTime) {
                endTime = endTime.substring(0, 10);
                let dateEnd = new Dates().unix(endTime);
                dura = EpgPersistence.needsOffset()
                  ? dateEnd.utcOffset(EpgPersistence.needsOffset(), false).format('HH:mm:ss')
                  : dateEnd.format('HH:mm:ss');
              }
            }
          }
        }
        else {
          dura = this.getDurationAsString();
        }
        this.refs.duration.innerHTML = dura;
      }
      else {
        if (streamContentType === constant.AAF_CONTENT_IS_STARTOVER) {
          if(this.state.timeshiftEventInfo && this.state.timeshiftEventInfo.event) {
            const dateEnd = this.getDatesArg(this.state.timeshiftEventInfo.event.date_end);
            dura = EpgPersistence.needsOffset()
              ? dateEnd.utcOffset(EpgPersistence.needsOffset(), false).format('HH:mm:ss')
              : dateEnd.format('HH:mm:ss');
          }
        }
        this.refs.duration.innerHTML = dura;
      }
    }
  }

  onPlayingSong() {
    store.dispatch(startPlaying());
  }

  onPlayingRadio() {
    store.dispatch(onPlayingRadio());
  }

  onFinishSong() {
    /**
     * *** Si user es suscrito, métrica se envía desde video/index, en método onEnded
     * <code>
     * TrackerManager.resetTimePlaying();
     * TrackerManager.end(secondsPlayingAudio);
     * </code>
     *
     * *** Si el user no tiene suscripción, el audiotrack se recorta
     * *** a 30 segundos y entonces aquí se manda la métrica
     */

    if (!store.getState().user.musicUser.hasSubscription) {
      this.props.sendMusicMetrics();
    }

    store.dispatch(finishPlaying());
  }

  onFavoriteSong() {

    this.sendMetric('agregar favorito');
    store.dispatch(doFavorite((isFavorite)=> this.toggleSongFavorite(isFavorite)));
  }

  toggleSongFavorite(isFavorite){
    const id = store.getState().playermusica.currentContent.id;
    let { isSongFavorite } = this.state;
      if (Utils.isNullOrUndefined(isSongFavorite)){
        isSongFavorite = isFavorite;
      }
      isSongFavorite = !isSongFavorite;
      this.setState({ isSongFavorite: isSongFavorite });
      observer.fire({
        isFavorite: isSongFavorite,
        trackId: id
      });
  }

  resetFavoriteBtnFromState(){
    this.setState({ isSongFavorite: null });
  }

  resetFavoriteBtn() {
    const btnFav = document.getElementById('favoriteBtn');
    btnFav
      .getElementsByTagName('img')[0]
      .setAttribute('src', Asset.get('player_controls_favorited'));
  }

  getDatesArg(tdate) {
    if(isNaN(tdate)) {
      // 2020/07/31 05:00:00
      // 0    5  8  11 14 17

      const years = tdate.substring(0, 4);
      const months = tdate.substring(5, 7);
      const date = tdate.substring(8, 10);
      const hours = tdate.substring(11, 13);
      const minute =tdate.substring(14,16);
      const seconds = tdate.substring(17, 19);

      return new Dates({ years, months, date, hours, minute, seconds });
    }
    else {
      return new Dates().unix(tdate);
    }
  }

  /**
   * Get current time as string
   * @param currentTime number
   * @returns {string}
   */
  getCurrentTimeAsString(currentTime) {
    if (
      parseInt(currentTime) === 31 &&
      (this.props.type === playerConstant.AUDIO || this.props.type === playerConstant.RADIO)
    ) {
      this.sendMetricMoreThan30Seconds();
    }
    if (this.props.type === playerConstant.RADIO) {
      return '--:--:--';
    }
    const time = typeof currentTime === 'number' ? currentTime : this.getCurrentTime();
    const streamContentType = this.props.streamContentType();
    if (streamContentType === constant.AAF_CONTENT_IS_VOD && time === 0) {
      this.hide();
    }

    if (streamContentType === constant.AAF_CONTENT_IS_STARTOVER) {
      if(this.state.timeshiftEventInfo && this.state.timeshiftEventInfo.event) {

        // 2020/07/31 05:00:00
        const dateBegin = this.getDatesArg(this.state.timeshiftEventInfo.event.date_begin);
        return EpgPersistence.needsOffset()
          ? dateBegin.add(time, 's').utcOffset(EpgPersistence.needsOffset(), false).format('HH:mm:ss')
          : dateBegin.add(time, 's').format('HH:mm:ss');
      }
      else {
        return new Dates({ hours: 0, minute: 0, seconds: 0 })
          .add(time, 's')
          .format('HH:mm:ss');
      }
    }
    else if (streamContentType === constant.AAF_CONTENT_IS_CATCHUP) {
      let startTime = null;
      let endTime = null;
      const resParams = this.props.playingResolvedParams();
      if(resParams && resParams.playerMedia) {
        if(resParams.playerMedia.entry) {
          startTime = resParams.playerMedia.entry.startTime;
          endTime = resParams.playerMedia.entry.endTime;
          if(startTime && endTime) {
            startTime = startTime.substring(0, 10);
            endTime = endTime.substring(0, 10);
            let dateBegin = new Dates().unix(startTime);
            return EpgPersistence.needsOffset()
              ? dateBegin.add(time, 's').utcOffset(EpgPersistence.needsOffset(), false).format('HH:mm:ss')
              : dateBegin.add(time, 's').format('HH:mm:ss');
          }
        }
      }

      return new Dates({ hours: 0, minute: 0, seconds: 0 })
        .add(time, 's')
        .format('HH:mm:ss');
    }
    else {
      return new Dates({ hours: 0, minute: 0, seconds: 0 })
        .add(time, 's')
        .format('HH:mm:ss');
    }
  }

  /**
   * Get duration time as string
   * @returns {string}
   */
  getDurationAsString() {
    if (this.props.type === playerConstant.RADIO) {
      return '--:--:--';
    } else {
      return this.duration
        ? new Dates({ hours: 0, minute: 0, seconds: 0 })
          .add(this.duration, 's')
          .format('HH:mm:ss')
        : '--:--:--';
    }
  }

  getDurationInMinutes() {
    return (this.getDuration() / 60.0).toFixed();
  }

  getCurrentTimeInMinutes() {
    return (this.getCurrentTime() / 60.0).toFixed();
  }

  handleLiveWithPlay() {
    let seekTo = this.state.timeshiftTime;
    if (this.state.timeshiftTime === 0 && this.getCurrentTime() === this.pendingLiveOnPause) {
      seekTo = this.pendingLiveOnPause;
    }

    this.pendingLiveOnPause = null;

    this.hide();
    this.setState({ playing: true }, this.focusPlayButton);

    let timeshiftData = {
      timeshiftEvent: Object.assign({}, this.state.timeshiftEventInfo.event),
      backward: true,
      seektime: seekTo,
      maxtimeshiftallowed: this.state.channelInfo.timeshiftAllowed,
      timeshiftDelay: null
    };
    this.isPlay = true;
    this.liveWasPause = false;
    this.performTimeshift(timeshiftData);
    this.waitForSeconds = false;
    this.forceStopAutoHide = false;
    this.verifySetAutoHide();
  }

  handleStartOverWithPlay() {
    // Si no hice nada, sólo pausa y luego play, me
    // voy a ese segundo en dónde hice la pausa
    if (this.state.timeshiftTime === 0) {
      this.state.timeshiftTime = this.pendingStartOverOnPause;
    }

    let seekTo = this.state.timeshiftTime;

    this.pendingStartOverOnPause = null;
    this.setState({ playing: true }, this.focusPlayButton);

    this.props.play();
    this.isPlay = true;
    let timeshiftData = {
      timeshiftEvent: Object.assign({}, this.state.timeshiftEventInfo.event),
      backward: true,
      seektime: seekTo,
      maxtimeshiftallowed: this.state.channelInfo.timeshiftAllowed,
      timeshiftDelay: null
    };

    this.performTimeshift(timeshiftData);
    this.waitForSeconds = false;
    this.forceStopAutoHide = false;
    this.verifySetAutoHide();
  }

  /**
   * Reset trick mode to 0
   */
  exitTrickMode() {
    // Romper el trickmode
    this.props.setSpeed(0);
    this.forceStopAutoHide = false;
    this.verifySetAutoHide();
  }

  play() {
    if (this.isInTrickMode && this.isPlay) {
      this.exitTrickMode();
      return;
    }

    // Nueva experiencia timeshift
    if (this.useTimeshiftEvent()) {
      // Es live
      if (this.isLiveWithTimeshiftEvent()) {
        return this.handleLiveWithPlay();
      }
      // Es start over
      if (this.isStartOverWithTimeshiftEvent()) {
        // Debería hacer pausa solamente
        return this.handleStartOverWithPlay();
      }
    } else {
      const liveTime_if = ChannelsSingleton.getTimeshift(TvChannelUtil.getLastChannel());
      if (liveTime_if === 0 && this.isLive()) {
        this.hide();
      }

      if (this.isLive()) {
        this.backwardTimeshiftUI();
      }
      this.sendMetric('reproducir');

      const state = store.getState();
      const statePlayerMusic = state.playermusica;
      const playlistLength = statePlayerMusic.playlist.originalContent.length;
      const currentIndex = parseInt(statePlayerMusic.currentContent.index);
      const isLastElement = playlistLength - 1 === currentIndex;

      if ((this.isVisible && this.canPlay) || this.props.type === playerConstant.AUDIO) {
        logger.debug('Playercontrols > play method');
        this.setState({ playing: true }, this.focusPlayButton);

        if (isLastElement && this.getCurrentTime() >= 29
          && store.dispatch(isPreviewSong())) {
              store.dispatch(showNotification({
                  show: true,
                  title: '',
                  msg: Translator.get('lastSong_alert_description_label', 'Esta es la última canción de la cola de reproducción'),
                  faClass: null,
                  type: 'music'
              }));
      } else {
          this.props.play(); // Play player device
          this.isPlay = true;
      }
        if (this.seekInPause) {
          Utils.seekInPause(this.props.seek, this.seekInPause);
          this.seekInPause = 0;
        }
      }

    }
    this.forceStopAutoHide = false;
    this.verifySetAutoHide();
  }

  sendDimension() {
    const payload = new AnalyticsDimensionSingleton().getPayload();
    this.props.setMetricsEvent(payload);
    this.props.setMetricsEvent({ type: 'executor' });
  }

  sendMetric(action, label = null) {
    const pgm = TrackerManager.getDataPgm();

    try {
      this.props.dataMetric.title = store.getState().resume.title;
      this.props.dataMetric.provider =
        pgm.response.group.common.extendedcommon.media.proveedor.nombre;
    } catch (e) {
      logger.debug('Send Metric TV');
    }

    if (typeof this.props.setMetricsEvent === 'function') {
      if (this.props.type === 'audio' || this.props.type === 'radio') {
        if (label === null) {
          label = DeviceStorage.getItem('label-music-analytics');
        }
        if (action === 'volver') {
          action = `${action}/${this.getCurrentTimeInMinutes()}/${this.getDurationInMinutes()}`;
        }
        this.props.setMetricsEvent({
          hitType: 'event',
          eventCategory: 'acciones',
          eventAction: action,
          eventLabel: label
        });
      } else {
        let provedor;
        const { dataMetric: {provider} } = this.props;
        const meta = Utils.getApaMetadataKey('transactional_configuration', '{}');
        const prov = meta.suscription.products[provider];
        if (label === null) {
          if (prov && prov[0] && prov.length === 1 && typeof prov[0] === 'string') {
            provedor = prov[0];
          } else {
            provedor = 'suscripcion';
          }
          label = `${provedor} - ${this.props.dataMetric.title}`;
        } else {
          label = `${label} - ${this.props.dataMetric.title}`;
        }
        if (action === 'volver') {
          action = `${action}/${this.getCurrentTimeInMinutes()}/${this.getDurationInMinutes()}`;
        }
        if (action === 'cambiar episodio') {
          const t = this.props.dataMetric.title.split(':');
          label = `${t[0]} - ${label}`;
        }

        this.props.setMetricsEvent({
          hitType: 'event',
          eventCategory: 'reproductor',
          eventAction: action,
          eventLabel: label
        });
      }

      this.props.setMetricsEvent({ type: 'executor' });
      this.sendDimension();
    }
  }

  sendMetricMoreThan30Seconds() {
    if (typeof this.props.setMetricsEvent === 'function') {
      const label = DeviceStorage.getItem('label-music-analytics') || '';
      if (label !== this.metricSend) {
        this.props.setMetricsEvent({
          hitType: 'event',
          eventCategory: 'reproductor',
          eventAction: 'completo+30',
          eventLabel: label
        });
        this.props.setMetricsEvent({
          type: 'executor'
        });
        this.metricSend = label;
        this.sendDimension();
      }
    }
  }

  closeModal(modalType) {
    if (!Utils.isModalHide() && modalType === Utils.modalType()) {
      store.dispatch({
        type: HIDE_MODAL,
        modalType
      });
    }
  }

  closeModalLang() {
    this.closeModal(MODAL_LANGUAGES);
  }

  backwardTimeshiftUI(pauseEnable = false) {
    let hasTshift = this.hasTimeshift();
    if (this.onLivePauseTimer) clearInterval(this.onLivePauseTimer);

    if (hasTshift && pauseEnable) {
      const timerExecuteMs = this.timePauseEventInterval * 60 * 1000;
      const timerExecuteMin = this.timePauseEventInterval * 60;
      this.state.timeshiftTime = this.getCurrentTime();

      this.onLivePauseTimer = setInterval(() => {
        let timePassingLeft = 0;

        if (this.state.timeshiftTime > 0 && !this.state.playing) {
          timePassingLeft = this.state.timeshiftTime - timerExecuteMin;
          timePassingLeft = timePassingLeft < 0 ? 0 : timePassingLeft;

          this.state.timeshiftTime = timePassingLeft;
          this.setCurrentTime(timePassingLeft);
          this.updateCurrentTimeUI(timePassingLeft);
        } else {
          // Self destroy
          clearInterval(this.onLivePauseTimer);
        }
      }, timerExecuteMs);
    }
  }

  /**
   * Nueva experiencia timeshift
   */
  handleLiveWithPause() {
    // Entra en start over
    //this.hide();
    this.sendMetric('pausa');
    if (this.canPlay) {
      this.pendingLiveOnPause = this.getCurrentTime();
      this.state.timeshiftTime = this.pendingLiveOnPause;
      this.props.pause();
      this.isPlay = false;
      this.liveWasPause = true;
      this.setState({ playing: false }, this.focusSlider);
    }
    this.forceStopAutoHide = false;
    this.verifySetAutoHide();
  }

  /**
   * Nueva experiencia timeshift
   */
  handleStartOverWithPause() {
    this.sendMetric('pausa');
    if (this.canPlay) {
      this.pendingStartOverOnPause = this.getCurrentTime();
      this.state.timeshiftTime = this.pendingStartOverOnPause;
      this.props.pause();
      this.isPlay = false;
      this.setState({ playing: false }, this.focusPlayButton);
    }
    this.forceStopAutoHide = false;
    this.verifySetAutoHide();
  }

  pause() {
    // Nueva experiencia timeshift
    if (this.useTimeshiftEvent()) {
      // Es live
      if (this.isLiveWithTimeshiftEvent()) {
        return this.handleLiveWithPause();
      }
      // Es start over
      if (this.isStartOverWithTimeshiftEvent()) {
        // Debería hacer pausa solamente
        return this.handleStartOverWithPause();
      }
    } else {
      const liveTime_if = ChannelsSingleton.getTimeshift(TvChannelUtil.getLastChannel());
      if (liveTime_if === 0 && this.isLive()) {
        this.hide();
      }
      this.sendMetric('pausa');

      const state = store.getState();
      const statePlayerMusic = state.playermusica;
      const playlistLength = statePlayerMusic.playlist.originalContent.length;
      const currentIndex = parseInt(statePlayerMusic.currentContent.index);
      const isLastElement = playlistLength - 1 === currentIndex;

      if (
        (this.isVisible && this.canPlay) ||
        this.props.type === playerConstant.AUDIO ||
        this.props.type === playerConstant.RADIO
      ) {
        logger.debug('Playercontrols > pause method');
        this.setState({ playing: false }, this.focusPlayButton);

        if (isLastElement && this.getCurrentTime() >= 29
          && store.dispatch(isPreviewSong())) {
              store.dispatch(showNotification({
                  show: true,
                  title: '',
                  msg: Translator.get('lastSong_alert_description_label', 'Esta es la última canción de la cola de reproducción'),
                  faClass: null,
                  type: 'music'
              }));
        } else {
          this.props.pause();
          this.isPlay = false;
        }

        if (this.isLive()) {
          //this.props.pause(this.hasTimeshift());
          this.props.pause();
          this.backwardTimeshiftUI(true);
        } else {
          this.props.pause();
        }
        this.isPlay = false;
      }
    }
    this.forceStopAutoHide = false;
    this.verifySetAutoHide();
  }

  seek(time) {
    /**
     * De acuerdo a este commit https://bitbucket.org/dlaargentina/stvreact/commits/9c72921b8d5978e76ad2046d184004a0da4c2122
     * si el player está en currenttime 0, se oculta playerControls (this.hide() y se pone la bandera this.isVisible = false).
     *
     * Pero esto de arriba no permite que se haga un seek a 0 en los primeros 29 segundos de reproducción
     * porque al hacer el seek al time=0 la bandera isVisible ya está en false, por tanto el seek no lo hace.
     * Se agrega validación extra para forzar seek en 0 (con doSeek var de abajo)
     */
    let doSeek = this.isVisible;
    if (time < 1 && !this.isVisible) {
      doSeek = true;
    }

    if ((doSeek || this.flagSkipIntro) && this.canPlay) {
      if (!this.state.playing) {
        this.seekInPause = time;
        this.setCurrentTime(this.seekInPause);
      } else {
        this.props.seek(time);
      }
    }
  }

  isFastRewindEnable() {
    return EventTimeshift.isTrickModeEnabled();
  }

  backward() {
    let fastRewindEnabled = this.isFastRewindEnable();
    //console.log('[SPEED PLAYER] PlayerControls > backward > isFastRewindEnable?: ' + (fastRewindEnabled ? 'TRUE' : 'FALSE'), this.props);

    const liveTime_if = ChannelsSingleton.getTimeshift(TvChannelUtil.getLastChannel());
    if (liveTime_if === 0 && this.isLive()) {
      this.hide();
    }

    if (this.props.type === playerConstant.AUDIO && store.dispatch(checkListType())) {
      return false;
    }
    if (this.isVisible && this.canPlay) {
      const streamContentType = this.props.streamContentType();
      //console.log('[SPEED PLAYER] PlayerControls > backward > streamContentType: ' + streamContentType);
      switch (streamContentType) {
        case constant.AAF_CONTENT_IS_TIMESHIFT:
        case constant.AAF_CONTENT_IS_TV:
          //console.log('[SPEED PLAYER] PlayerControls > backward > isTV > handleTimeshiftSeek');
          this.handleTimeshiftSeek(true, this.settings.backwardTime_timeshift);
          break;
        case constant.AAF_CONTENT_IS_STARTOVER:
          // Si estoy en startOver y el fastFostward está habilitado?
          if (fastRewindEnabled) {
            // Si está por hacer seek return
            if (this.isMoving) {
              return;
            }

            if (!this.isPlay) {
              // Reset
              this.pendingLiveOnPause = null;
              this.pendingStartOverOnPause = null;
              this.state.timeshiftTime = 0;

              // Si esta en pausa
              this.player.resume();
              this.isPlay = true;
              this.setState({ playing: true }, () => {
                this.props.speedBackward();
              });
            } else {
              this.props.speedBackward();
            }
          } else {
            //console.log('[SPEED PLAYER] PlayerControls > backward > isStartOver > handleTimeshiftSeek');
            this.handleTimeshiftSeek(true, this.settings.backwardTime_timeshift);
          }
          break;
        case constant.AAF_CONTENT_IS_NPVR:
        case constant.AAF_CONTENT_IS_CATCHUP:
          if (fastRewindEnabled) {
            // Si está por hacer seek se bloquea el trickPlay
            if (this.isMoving) {
              return;
            }
            if (!this.isPlay) {
              this.player.resume();
              this.isPlay = true;
              this.setState({ playing: true }, () => {
                this.props.speedBackward();
              });
            } else {
              this.props.speedBackward();
            }
          } else {
            //console.log('[SPEED PLAYER] PlayerControls > backward > isStartOver > calculateFinalSeekTime');
            this.calculateFinalSeekTime(true, this.settings.backwardTime);
          }
          break;
        case constant.AAF_CONTENT_IS_VOD:
        case constant.AAF_CONTENT_IS_AUDIO:
          //console.log('[SPEED PLAYER] PlayerControls > backward > isStartOver > calculateFinalSeekTime');
          this.calculateFinalSeekTime(true, this.settings.backwardTime);
          break;
        default:
          logger.debug('<< Stream no controlado', streamContentType);
      }
    }
    this.forceStopAutoHide = true;
    this.verifySetAutoHide(true);
  }

  /*
   TODO verificar si este boton: regresar en tiempo y/o en serie regresar cap anterior
   */
  stepBackward() {
    if (this.isVisible) {
      const streamContentType = this.props.streamContentType();
      switch (streamContentType) {
        case constant.AAF_CONTENT_IS_TIMESHIFT:
          if (!this.state.timeshiftEventInfo) {
            this.handleTimeshiftSeekByAll(
              true,
              this.settings.stepBackwardTime_timeshift
            );
          }
          break;
        case constant.AAF_CONTENT_IS_TV:
          logger.debug('|<< LIVE');
          if (this.state.timeshiftEventInfo && this.state.timeshiftEventInfo.event) {
            this.handleTimeshiftSeekByEvent(true, 0);
          } else {
            this.handleTimeshiftSeekByAll(
              true,
              this.settings.stepBackwardTime_timeshift
            );
          }
          break;
        case constant.AAF_CONTENT_IS_STARTOVER:
          logger.debug(' |<< START OVER');
          this.handleTimeshiftSeek(true, 0);
          break;
        case constant.AAF_CONTENT_IS_VOD:
        case constant.AAF_CONTENT_IS_CATCHUP:
          logger.debug(' |<< VOD');
          this.calculateFinalSeekTime(true, this.settings.stepBackwardTime);
          break;
        default:
          logger.debug(' |<< Stream no controlado', streamContentType);
      }
    }
  }

  fastBackward() {
    TrackerManager.rewind30(this.player.getCurrentTime());
    this.sendMetric('Atrasar 30 segundos');

    if (this.isVisible && this.canPlay) {
      this.calculateFinalSeekTime(true, this.settings.fastBackwardTime);
    }
  }

  forward() {
    let fastRewindEnabled = this.isFastRewindEnable();
    //console.log('[SPEED PLAYER] PlayerControls > forward > isFastRewindEnable?: ' + (fastRewindEnabled ? 'TRUE' : 'FALSE'));
    const liveTime_if = ChannelsSingleton.getTimeshift(TvChannelUtil.getLastChannel());
    if (liveTime_if === 0 && this.isLive()) {
      this.hide();
    }
    //this.sendMetric('adelantar');

    if (this.props.type === playerConstant.AUDIO && store.dispatch(checkListType())) {
      return false;
    }

    if (this.isVisible && this.canPlay) {
      const streamContentType = this.props.streamContentType();
      switch (streamContentType) {
        case constant.AAF_CONTENT_IS_TIMESHIFT:
          //console.log('[SPEED PLAYER] PlayerControls > backward > isTV > handleTimeshiftSeek');
          this.handleTimeshiftSeek(false, this.settings.backwardTime_timeshift);
          break;
        case constant.AAF_CONTENT_IS_TV:
          //console.log('[SPEED PLAYER] PlayerControls > forward');
          break;
        case constant.AAF_CONTENT_IS_STARTOVER:
          // Si estoy en startOver y el fastFostward está habilitado?
          if (fastRewindEnabled) {
            // Si está por hacer seek return
            if (this.isMoving) {
              return;
            }

            // Si está en pausa
            if (!this.isPlay) {
              // Reset
              this.pendingLiveOnPause = null;
              this.pendingStartOverOnPause = null;
              this.state.timeshiftTime = 0;

              this.player.resume();
              this.isPlay = true;
              this.setState({ playing: true }, () => {
                this.props.speedForward();
              });
            } else {
              this.props.speedForward();
            }
          } else {
            this.handleTimeshiftSeek(false, this.settings.forwardTime_timeshift);
          }
          break;
        case constant.AAF_CONTENT_IS_NPVR:
        case constant.AAF_CONTENT_IS_CATCHUP:
          if (fastRewindEnabled) {
            // Si está por hacer seek se bloquea el trickPlay
            if (this.isMoving) {
              return;
            }

            if (!this.isPlay) {
              this.player.resume();
              this.isPlay = true;
              this.setState({ playing: true }, () => {
                this.props.speedForward();
              });
            } else {
              this.props.speedForward();
            }
          } else {
            this.calculateFinalSeekTime(false, this.settings.forwardTime);
          }
          break;
        case constant.AAF_CONTENT_IS_VOD:
        case constant.AAF_CONTENT_IS_AUDIO:
          this.calculateFinalSeekTime(false, this.settings.forwardTime);
          break;
        default:
          logger.debug(' >> Stream no controlado', streamContentType);
      }
    }
    this.forceStopAutoHide = true;
    this.verifySetAutoHide(true);
  }

  /*
   TODO verificar si este boton: adelantar en tiempo y/o en serie regresar cap siguiente
   */
  stepForward() {
    const streamContentType = this.props.streamContentType();
    switch (streamContentType) {
      case constant.AAF_CONTENT_IS_TIMESHIFT:
        if (!this.state.timeshiftEventInfo) {
          this.handleTimeshiftSeekByAll(false, this.settings.stepForwardTime_timeshift);
        }
        break;
      case constant.AAF_CONTENT_IS_TV:
        logger.debug(' >>| LIVE (NOTHING)');
        if (!this.state.timeshiftEventInfo) {
          this.handleTimeshiftSeekByAll(false, this.settings.stepForwardTime_timeshift);
        }
        break;
      case constant.AAF_CONTENT_IS_STARTOVER:
        logger.debug(' >>| START OVER');
        this.back();
        break;
      case constant.AAF_CONTENT_IS_VOD:
      case constant.AAF_CONTENT_IS_CATCHUP:
        logger.debug(' >>| VOD');
        this.calculateFinalSeekTime(true, this.settings.stepForwardTime);
        break;
      default:
        logger.debug(' >>| Stream no controlado', streamContentType);
    }
  }

  fastForward() {
    TrackerManager.foward30(this.player.getCurrentTime());
    this.sendMetric('adelantar 30 segundos');

    if (this.isVisible && !this.isLive() && this.canPlay) {
      this.calculateFinalSeekTime(false, this.settings.fastForwardTime);
    }
  }

  replay() {
    if (this.isVisible) {
      this.props.replay();
    }
  }

  back(withHistoryBack) {
    this.initSpriteConfig();

    this.pendingStartOverOnPause = null;
    this.pendingLiveOnPause = null;
    this.sendMetric('volver');
    // document.removeEventListener('keydown', this.keyPressHandler);
    this.hide();
    this.resetFavoriteBtnFromState();
    if (this.isStartOverWithTimeshiftEvent()) {
      FallbackUtil.clearFallback();
      //console.log('PAU> function back > ' + this.switchingBetweenEventTimeshift);
      this.switchingBetweenEventTimeshift = !this.switchingBetweenEventTimeshift;
      this.props.goToLive(this.setTimer);
    } else {
      this.props.back(withHistoryBack);
    }
    this.forceStopAutoHide = false;
    this.verifySetAutoHide(true);
  }

  next() {
    if (this.isVisible) {
      this.props.next();
    }
  }

  nextSong() {
    if (store.dispatch(canGoToNextSong())) {
      this.sendMetric('siguiente cancion');
      //this.resetFavoriteBtn();
      this.resetFavoriteBtnFromState();
      store.dispatch(goToNextSong(this.getCurrentTime()));
    }
  }

  previewSong() {
    this.sendMetric('anterior cancion');
    //this.resetFavoriteBtn();
    this.resetFavoriteBtnFromState();
    store.dispatch(goToPreviewSong(this.getCurrentTime()));
  }

  doRepeat() {
    this.sendMetric('repetir');
    store.dispatch(doToggleRepeat());
  }

  doShuffle() {
    const actShuffle = store.dispatch(doToggleShuffle());
    this.sendMetric('aleatorio');
    if (actShuffle) {
      const btnShuffle = document.getElementById('shuffleBtn');
      const img = btnShuffle.getElementsByTagName('img')[0].getAttribute('src');
      if (img.indexOf('controls_random.png') !== -1) {
        btnShuffle
          .getElementsByTagName('img')[0]
          .setAttribute('src', Asset.get('player_controls_random_selected'));
      } else {
        btnShuffle
          .getElementsByTagName('img')[0]
          .setAttribute('src', Asset.get('player_controls_random'));
      }
    }
  }

  record() {
    let currentEvent = this.currentEvent;
    const streamContentType = this.props.streamContentType();
    switch (streamContentType) {
      case constant.AAF_CONTENT_IS_CATCHUP:
        const playerState = store.getState().player;
        if (playerState && typeof playerState.event === 'object') {
          currentEvent = playerState.event;
        }
        break;
      default:
        break; // Se deja la lógica que ya estaba
    }

    if (this.isVisible && currentEvent) {
      this.props.record(currentEvent);
    }
  }

  resetSeekInPause() {
    this.seekInPause = 0;
  }

  changeLang(e) {
    logger.debug('[MA-LIVE]-e', e);
    TrackerManager.audioChange(this.player.getCurrentTime());
    this.sendMetric('idioma', e.label_short);
    if (this.seekInPause) {
      e.resume = this.seekInPause;
    }
    this.actions = {
      play: () => this.play(),
      resetSeekInPause: () => this.resetSeekInPause()
    };
    try {
      this.props.changeLang(e, this.actions);
      //Fix oculta player controls, para no mostrar el resete en el current time al hacer cambio de idioma
      this.hide();
    } catch (e) {
      logger.error('Error changeLang:', e);
    }
  }

  static onUpdateLangOptions(langOptions) {
    logger.debug('[MA-LIVE]-langOptions', langOptions);
    PlayerControlsLegacy.languageOptions = langOptions;
  }

  changeLangLive(isAudio, it) {
    it.isAudio = isAudio;
    this.changeLang(it);
  }



  showLangModal() {
    const isLive =
      this.isLive() || this.props.streamContentType() === constant.AAF_CONTENT_IS_CATCHUP
      || (isAndroidDevice() && this.props.streamContentType() === constant.AAF_CONTENT_IS_NPVR);

    if (isLive) {
      const streamType = this.getStreamType();
      if (
        MultipleLangLive.isEnabled() &&
        streamType &&
        MultipleLangLive.streamIsEnabled(streamType)
      ) {
        const newOptions = isAndroidDevice() ? PlayerAudioSubtitleHelper.getAndroidAudioSubtitleLive(this.trackInfo) : PlayerControlsLegacy.languageOptions;
        const options = newOptions ? newOptions : MultipleLangLive.defaultOptionsModal();
        store.dispatch(
          showModal({
            modalType: MODAL_LANGUAGES_LIVE,
            modalProps: {
              languages: options,
              callback: (isAudio, a) => {
                this.changeLangLive(isAudio, a);
              }
            }
          })
        );
      } else {
        const modalProps = {
          callback: null,
          content: {
            message: Translator.get(
              'not_available_options',
              'No hay opciones disponibles'
            )
          }
        };
        store.dispatch(
          showModal({
            modalType: AAF_MODAL_ERROR,
            modalProps
          })
        );
      }
    } else {
      let languages = null;
      if (this.props.streamContentType() !== constant.AAF_CONTENT_IS_NPVR) {
        languages =
          PlayerControlsLegacy.languageOptions && PlayerControlsLegacy.languageOptions.length > 0
            ? PlayerControlsLegacy.languageOptions
            : this.props.jsonLangs;
      }
      store.dispatch(
        showModal({
          modalType: MODAL_LANGUAGES,
          modalProps: {
            languages,
            callback: this.changeLang
          }
        })
      );
    }
  }

  updateSpriteSrc(episode = {}) {
    this.imageSpriteURLnew = episode.image_sprites;
  }

  async handleEpisodeClick(episode = {}) {
    let that = this;
    logger.debug('[PlayerControls] episode:', episode);
    this.__isNextEpisodeAvailable(episode)
      .then(function(response) {
        logger.debug('[PlayerControls] El siguiente contenido SI se puede ver', response);
        that.sendMetric('cambiar episodio ' + episode.title_episode);

        that.updateSpriteSrc(episode);
        if (episode && episode.image_sprites) {
          episode.spriteImage = episode.image_sprites;
        }
        store.dispatch(setResumeData(episode));

        EventEmitter.emit('player:episodeChange', { groupId: episode.id });

        if (that.props.changeContentfromSelector) {
          return that.props.changeContentfromSelector(episode.id);
        }
        const groupId = episode.id;
        const state = {
          isTrailer: false,
          serieData: {
            seasons: that.props.serieData.seasons,
            episodeNumber: episode.episode_number,
            seasonNumber: episode.season_number
          }
        };
        that.addListeners();
        that.props.handleRedirect(`/player/${groupId}`, state, true);
        /* Inicio de comentarios que ya estaban */
        // GET MEDIA
        //TrackerManager.pgm(this.player.getCurrentTime());
        // TrackerManager.playing(this.player.getCurrentTime());
        /* Fin de comentarios que ya estaban */
      })
      .catch(error => {
        logger.debug('[PlayerControls] El siguiente contenido NO se puede ver', error);
        //Se mostrará en modal de error que provenga del error (error.errors[0].code)
        this.showModalNotPurchasedEpisodeError(error);
      });
  }

  /*
   * Modal que muestra el error de que el contenido que se intenta reproducir no está disponible
   */

  showModalNotPurchasedEpisodeError(error) {
    /* El valor 'PLY_PLY_00007' podría cambiar en APA, por lo que es necesaria una mejor forma de obtener esa referencia, desde API por ejemplo */
    let code =
      error && error.errors && error.errors[0].code ? error.errors[0].code : 'PLY_PLY_00007';
    let errorMsg = Translator.get(code, '');
    const modalProps = {
      callback: null,
      content: { message: errorMsg }
    };
    const modal = {
      modalType: AAF_MODAL_ERROR,
      modalProps
    };
    store.dispatch(showModal(modal));
  }

  /*
   *   Método que indica que el siguiente contenido esta disponible, devolviendo la respuesta como error
   *   si no está comprado o no disponible.
   */
  __isNextEpisodeAvailable(episode) {
    return new Promise((resolve, reject) => {
      api.purchaseButtonInfo(episode.id).then(response => {
        let waspurchased = 0;
        if (response.playButton && response.playButton.waspurchased) {
          waspurchased = parseInt(response.playButton.waspurchased);
        }
        logger.debug('[PlayerControls] respuesta de la purchaseButtonInfo: ', response);
        if (waspurchased === 1) {
          resolve(true);
        } else {
          reject(response);
        }
      });
    });
  }

  showSeasonsModal() {
    if (this.isVisible) {
      const modal = {
        modalType: MODAL_EPISODE_SELECT,
        modalProps: {
          serieData: this.serieData,
          handleEpisodeClick: this.handleEpisodeClick,
          onClose: () => this.addListeners()
        }
      };
      store.dispatch(showModal(modal));
    }
  }

  showFullEpg() {
    if (this.isVisible) {
      this.props.handleFullEpg('GUIDE');
      this.isVisible = false;
      this.hide();
    }
  }

  /**
   * hide controls
   */
  hide = () => {

    // Si esta habilitado para el stream type, se ejecuta el método, de otra forma rejected
    // Para controlar los observers
    if(!this.enabledForThisContentStreamType()) return;

    if (
      EpgPersistence.isEnabled() &&
      store.getState().player &&
      store.getState().player.islive
    ) {
      HideMiniObserver.fire();
    }
    logger.debug('[PlayerControls] hide');
    logger.debug('[PlayerControls][miniEpg] hide');
    this.imageSpriteURLnew = ''; //To reset URL sprites when changing channels from episodes selector when playing
    let isAudio =
      this.props.type === playerConstant.AUDIO || this.props.type === playerConstant.RADIO;
    const coverFlowIsActive = document.querySelector('.epg-cover-flow');
    this.hideControls(this.state.actionBar.isVisible);
    this.skipIntroPositionDown();
    clearInterval(this.timer);
    if (this.refs && this.refs.container && !isAudio && !coverFlowIsActive) {
      const className = this.refs.container.className;
      this.refs.container.className =
        className.indexOf('hide-controls') === -1
          ? `${className} ${this.hasEpgErrorOnLive() ? '' : 'hide-controls'}`
          : className;
      this.isVisible = false;
      PlayerControlsLegacy.isVisible = false;
      this.props.controlBarIsShowed(this.isVisible);
      this.onHideListeners.forEach(el => {
        el && el();
      });
    }
    this.forceStopAutoHide = false;
  };

  /**
    * @param {*} streamContentType
    * Método para ayudar a controlar observers
    * ShowPlayerControlsObserver / HidePlayerControlsObserver
    */
  enabledForThisContentStreamType(streamContentType = null) {
    return this.props.useNewPlayerControls() ? false : true;
  }

  /**
   * Show controls and set a timer for hide
   */
  show = currentKey => {
    // Si esta habilitado para el stream type, se ejecuta el método, de otra forma rejected
    // Para controlar los observers
    if(!this.enabledForThisContentStreamType()) return;

    const streamContentType = this.props.streamContentType();
    if (streamContentType === constant.AAF_CONTENT_IS_VOD && this.getCurrentTime() === 0) {
      return;
    }

    if (constant.AAF_CONTENT_IS_TV && !this.isPlay && this.liveWasPause) {
      //si fue el live pausado mostramos controles y no mini
      const className = this.refs.container.className;
      if (className.indexOf('show-mini-epg') > -1) {
        this.showControls();
      }
    }
    if (this.props.checkStatusEPG) return;

    const isHidden = this.refs.container.className.indexOf('hide-controls') > -1;
    if (
      EpgPersistence.isEnabled() &&
      store.getState().player &&
      store.getState().player.islive &&
      !(this.props.type === playerConstant.AUDIO || this.props.type === playerConstant.RADIO)
    ) {
      if (!this.enabledControlsTS()) {
        ShowMiniObserver.fire();
      }
    }
    if (
      this.props.streamContentType() === constant.AAF_CONTENT_IS_VOD ||
      this.props.streamContentType() === constant.AAF_CONTENT_IS_STARTOVER
    ) {
      HideMiniObserver.fire();
    }
    //Si hay un error de la EPG no mostrar este control
    if (this.hasEpgErrorOnLive()) {
      this.isVisible = false;
      //this.props.launchCoverFlow(true);
      //TODO: activar el coverFlow
      return;
    }

    const reduxState = store.getState();
    if (
      reduxState.player &&
      reduxState.player.source &&
      this.props.epgGroupId &&
      !isNaN(reduxState.player.source.videoid) &&
      reduxState.player.source.videoid != this.props.epgGroupId &&
      this.currentEvent &&
      reduxState.player.source.videoid != this.currentEvent.groupId &&
      !EpgPersistence.isEnabled()
    ) {
      this.isVisible = false;
      return;
    }

    // [TIZEN][resetPlayerStatus] After the key is pressed the flag returns to its normal state.
    this.isFocusButton = false;

    if (this.refs && this.refs.container && !this.props.checkStatusEPG) {
      let className = this.refs.container.className;
      if (this.enabledControlsTS()) {
        className = className.replace('show-mini-epg', 'show-controls');
        window.SpatialNavigation.enable('player_controls');
        this.firstControlsShow = true;
      }
      this.refs.container.className = `${className.replace(' hide-controls', '')}`;
      this.isVisible = true;
      PlayerControlsLegacy.isVisible = true;
      this.skipIntroPositionUp();
      this.setTimer();
      if (!this.isLive()) {
        window.SpatialNavigation.enable('player_controls');
      }
      this.props.controlBarIsShowed(this.isVisible);
    }

    this.setfocusMiniEpg(currentKey);
  };

  enabledControlsTS() {
    if (
      EventTimeshift.isEnabled() &&
      this.isLive() &&
      this.props.streamContentType &&
      typeof this.props.streamContentType == 'function'
    ) {
      return this.props.streamContentType() === constant.AAF_CONTENT_IS_STARTOVER;
    } else {
      return false;
    }
  }

  setfocusMiniEpg(currentKey) {
    let sendMoveSpatial = {};
    if (currentKey === 'CH_DOWN' || currentKey === 'CH_UP') {
      if(Utils.modalType() === MODAL_INACTIVITY){
        e.preventDefault();
          e.stopPropagation();
        return;
      }
      sendMoveSpatial = { currentKey };
      if (
        this.isVisible &&
        this.isLive() &&
        Utils.isModalHide()
      ) {
        setTimeout(() => {
          this.focusMiniEpg(sendMoveSpatial);
        }, 300);
      }
    }
  }

  hasEpgErrorOnLive() {
    return this.props.hasEpgError() && this.isLive();
  }

  /**
   * Position Skip Intro
   */
  skipIntroPositionUp() {
    if (this.refs && this.refs.skipIntro && this.hasSkipIntro) {
      const className = this.refs.skipIntro.className;
      const classNameReplace = className.replace('skip-intro-down', 'skip-intro-up');
      this.refs.skipIntro.className =
        className.indexOf('skip-intro-down') > -1 ? classNameReplace : className;
    }
  }

  skipIntroPositionDown() {
    if (this.refs && this.refs.skipIntro && this.hasSkipIntro) {
      const className = this.refs.skipIntro.className;
      const classNameReplace = className.replace('skip-intro-up', 'skip-intro-down');
      this.refs.skipIntro.className = classNameReplace;
      this.doFocusableSkipIntro();
    }
  }

  toggleControlsVod = () => {
    if (this.isVisible) this.hide();
    else this.show();
  };

  showControls() {
    if (this.isLive() && this.refs.container) {
      const className = this.refs.container.className;
      // this.refs.container.className = `${className} mini-epg-visible`;
      if (this.enableButton('yellow') || !config_remote_control) {
        this.refs.container.className = `${className.replace(
          'show-mini-epg',
          'show-controls'
        )}`;
        this.setState({ showBlueButton: false });
        this.firstControlsShow = true;
      }
      window.SpatialNavigation.enable('player_controls');
      //   this.setState({showControls: true}, () => setTimeout(this.focusPlayButton, 300));
    }
  }

  enableButton(colorCode) {
    return Utils.isColorInPlayerControlEnable(colorCode);
  }

  hideControls(actionBarIsVisible) {
    if (this.isLive() && this.refs.container) {
      const className = this.refs.container.className;
      // this.refs.container.className = `${className.replace(' mini-epg-visible', '')}`;
      this.refs.container.className = `${className.replace(
        'show-controls',
        'show-mini-epg'
      )}`;
      this.verifySetAutoHide();

      let estate = { showBlueButton: true };
      if (Utils.isNotNullOrNotUndefined(actionBarIsVisible) && actionBarIsVisible === true) {
        estate.actionBar = {
          isVisible: false,
          title: '',
          channel: '',
          event: {}
        };
      }

      this.setState(estate);
      window.SpatialNavigation.disable('player_controls');
      // this.setState({showControls: false}, () => setTimeout(this.focusMiniEpg, 200));
    }
  }

  toggleControls() {
    if (this.enabledControlsTS()) {
      return;
    }

    if (this.refs && this.refs.container) {
      this.show();
      const className = this.refs.container.className;
      if (className.includes('show-mini-epg')) {
        if (EpgPersistence.isEnabled()) {
          HideMiniObserver.fire();
        }

        this.showControls();
        if (this.firstControlsShow) {
          this.focusPlayButton();
          this.firstControlsShow = false;
        }
      } else {
        if (EpgPersistence.isEnabled()) {
          ShowMiniObserver.fire();
        }
        this.hideControls();
      }
    }
  }

  /**
   * Slider side actions
   * @param e
   */
  slide(e) {
    logger.debug('Playercontrols slide events');
    if (!this.isVisible) {
      return false;
    }

    if (!this.canPlay) {
      return false;
    }

    if (this.props.type === playerConstant.AUDIO && store.dispatch(checkListType())) {
      return false;
    }

    const { direction } = e.detail;
    switch (direction) {
      case 'left':
        e.preventDefault();
        if (!this.isLive()) {
          this.calculateFinalSeekTime(true, this.settings.slideTime);
        } else {
          this.handleTimeshiftSeek(true, this.settings.slideTime_timeshift);
        }
        break;
      case 'right':
        e.preventDefault();
        if (!this.isLive()) {
          this.calculateFinalSeekTime(false, this.settings.slideTime);
        } else {
          this.handleTimeshiftSeek(false, this.settings.slideTime_timeshift);
        }
        break;
      default:
    }
  }

  handleTimeshiftSeek(isBackward, seekTime) {
    FallbackUtil.clearFallback();
    if (this.state.timeshiftEventInfo && this.state.timeshiftEventInfo.event) {
      this.handleTimeshiftSeekByEvent(isBackward, seekTime);
    } else {
      this.handleTimeshiftSeekByAll(isBackward, seekTime);
    }
  }

  /**
   * Timeshift handler nueva experiencia, timeshift by event
   * @param {*} isBackward true if go back, false ahead
   * @param {*} seekTime seconds to go to
   */
  handleTimeshiftSeekByEvent(isBackward, seekTime) {
    if (this.switchingBetweenEventTimeshift) {
      logger.debug('PAU> function handleTimeshiftSeekByEvent rejected*****> ');
      return;
    }

    logger.debug('PAU> PlayerControls > handleTimeshiftSeekByEvent seekTime: ', seekTime);
    //console.log('PAU> PlayerControls > handleTimeshiftSeekByEvent this.state.timeshiftTime: ', this.state.timeshiftTime);
    let isLive = null;

    if (this.hasTimeshift()) {
      if (this.timerTimeshitDelayId) clearTimeout(this.timerTimeshitDelayId);
      let currTime = this.waitForSeconds ? this.state.timeshiftTime : this.getCurrentTime();

      //console.log('PAU> PlayerControls > handleTimeshiftSeekByEvent currTime es: ', currTime);
      if (isBackward) {
        if (this.isLiveWithTimeshiftEvent()) {
          if (!this.waitForSeconds) this.waitForSeconds = true;
          isLive = true;
          // Protejemos al player¿? con algún threshold? en live
          const threshold_seconds = 0.25 * 60; // se permite timeshift medio minuto después de que comenzó el contenido
          if (
            Utils.nowAsTimestampSeconds() -
            this.state.timeshiftEventInfo.event.date_begin >
            threshold_seconds
          ) {
            const newCurrentTime = currTime - seekTime < 0 ? 0 : currTime - seekTime;
            this.setCurrentTime(newCurrentTime);
            if (newCurrentTime < currTime) {
              this.state.timeshiftTime = newCurrentTime; // Sólo como flag
            }
            //console.log('PAU> PlayerControls > handleTimeshiftSeekByEvent > es backward en live, se hará timeshift a : ', newCurrentTime, '<> this.state.timeshiftTime: ', this.state.timeshiftTime);
          }
        }
        if (this.isStartOverWithTimeshiftEvent()) {
          if (!this.waitForSeconds) this.waitForSeconds = true;

          isLive = false;

          const threshold_seconds = 0.5 * 60; // se permite timeshift medio minuto después de que comenzó el contenido
          if (
            Utils.nowAsTimestampSeconds() -
            this.state.timeshiftEventInfo.event.date_begin >
            threshold_seconds
          ) {
            const newCurrentTime = currTime - seekTime < 0 ? 0 : currTime - seekTime;
            this.setCurrentTime(newCurrentTime);
            if (newCurrentTime < currTime) {
              this.state.timeshiftTime = newCurrentTime; // Sólo como flag

              // Si estamos en pausa y regresamos todo a cero, entons hacemos seek cero cuando se reanude el play
              if (this.pendingStartOverOnPause !== null && newCurrentTime === 0) {
                this.pendingStartOverOnPause = 0;
              }
            }
            //console.log('PAU> PlayerControls > handleTimeshiftSeekByEvent > es backward en live, se hará timeshift a : ', newCurrentTime, '<> this.state.timeshiftTime: ', this.state.timeshiftTime);
          }
        }
      }
      // Si es forward
      else {
        if (this.isLiveWithTimeshiftEvent()) {
          isLive = true;
          if (this.pendingLiveOnPause !== null) {
            const newCurrentTime =
              currTime + seekTime > this.pendingLiveOnPause
                ? this.pendingLiveOnPause
                : currTime + seekTime;
            this.setCurrentTime(newCurrentTime);
            this.state.timeshiftTime = newCurrentTime; // Sólo como flag
          } else {
            return;
          }
        }
        if (this.isStartOverWithTimeshiftEvent()) {
          isLive = false;

          if (
            Utils.nowAsTimestampSeconds() > this.state.timeshiftEventInfo.event.date_end
          ) {
            return;
          }

          if (!this.waitForSeconds) this.waitForSeconds = true;

          const threshold_seconds_forward = 0.25 * 60; // no se permite avanzar hasta el now del evento, sólo hasta 25 segs antes
          //let acum_forward = currTime + this.state.timeshiftEventInfo.event.date_begin;
          let limit_forward =
            this.state.timeshiftEventInfo.event.date_end -
            Utils.nowAsTimestampSeconds() -
            threshold_seconds_forward;
          let dur_limit_forward =
            this.state.timeshiftEventInfo.event.date_end -
            this.state.timeshiftEventInfo.event.date_begin -
            limit_forward;

          logger.debug(
            'PAU> PlayerControls > handleTimeshiftSeekByEvent > seek forward SI se permite'
          );

          let newCurrentTime;
          if (currTime + seekTime > dur_limit_forward) {
            this.switchingBetweenEventTimeshift = true;
            this.waitForSeconds = false;
            logger.debug(
              'PAU> function handleTimeshiftSeekByEvent skip to live > ' +
              this.switchingBetweenEventTimeshift
            );
            FallbackUtil.clearFallback();
            this.hide();
            this.props.goToLive(this.setTimer);
            return;
          } else {
            newCurrentTime = currTime + seekTime;
          }
          //let newCurrentTime = currTime + seekTime > dur_limit_forward ? dur_limit_forward : currTime + seekTime;
          this.setCurrentTime(newCurrentTime);

          if (newCurrentTime > currTime) {
            this.state.timeshiftTime = newCurrentTime; // Sólo como flag
          } else {
            this.state.timeshiftTime = dur_limit_forward; // Sólo como flag
          }

          logger.debug('PAU4> currTime: ', currTime);
          logger.debug('PAU4> newCurrentTime: ', newCurrentTime);
          logger.debug('PAU4> currTime + seekTime: ', currTime + seekTime);
          logger.debug('PAU4> dur_limit_forward: ', dur_limit_forward);
          logger.debug('PAU4> this.state.timeshiftTime: ', this.state.timeshiftTime);
        }
      }

      let timeshiftDelay = this.getDuration() - this.getCurrentTime();
      let timeshiftData = {
        timeshiftEvent: Object.assign({}, this.state.timeshiftEventInfo.event),
        backward: isBackward,
        // Si es negativo o no, se verifica en video/component, quien es quien decide
        // si se va o no a pgm o solo hace seek sobre el actual playing
        seektime: this.state.timeshiftTime,
        maxtimeshiftallowed: this.state.channelInfo.timeshiftAllowed,
        timeshiftDelay
      };

      logger.debug(
        'PAU> PlayerControls > handleTimeshiftSeekByEvent > this.getCurrentTime() : ',
        this.getCurrentTime()
      );
      this.updateCurrentTimeUI(this.getCurrentTime());
      // Si esta en live y en pausa entonces esta haciendo seeks y no se hace timeshift aún
      if (this.pendingLiveOnPause !== null || this.pendingStartOverOnPause !== null) {
        return;
      }

      this.timerTimeshitDelayId = setTimeout(() => {
        this.timerTimeshitDelayId = null;
        this.performTimeshift(timeshiftData);
        this.waitForSeconds = false;
      }, this.delayTimeshiftSeek);
    }
  }

  /**
   * * Timeshift handler vieja experiencia, cuando se pide todo el timeshift hacía atrás
   * @param {*} isBackward
   * @param {*} seekTime
   */
  handleTimeshiftSeekByAll(isBackward, seekTime) {
    logger.debug('PAU2> PlayerControls > handleTimeshiftSeek seekTime: ', seekTime);
    if (this.hasTimeshift()) {
      logger.debug('PAU> PlayerControls > handleTimeshiftSeek, hasTimeshift=true');
      if (this.timerTimeshitDelayId) clearTimeout(this.timerTimeshitDelayId);
      let currTime = this.getCurrentTime();
      logger.debug('PAU> PlayerControls > handleTimeshiftSeek, currTime: ' + currTime);
      if (isBackward) {
        logger.debug('[PS4 TSH] enter handleTimeshiftSeek isBackward = true');
        const newCurrentTime = currTime - seekTime < 0 ? 0 : currTime - seekTime;
        this.setCurrentTime(newCurrentTime);
        //if(this.isLive() && isBackward && (newCurrentTime < this.getCurrentTime())){
        if (this.isLive() && isBackward && newCurrentTime < currTime) {
          this.state.timeshiftTime = newCurrentTime; // Sólo como flag
        }
      } else {
        const newCurrentTimeForward =
          currTime + seekTime > this.getDuration()
            ? this.getDuration()
            : currTime + seekTime;
        this.setCurrentTime(newCurrentTimeForward);
        if (this.isLive() && newCurrentTimeForward > currTime) {
          this.state.timeshiftTime = newCurrentTimeForward;
        }
      }

      let timeshiftDelay = this.getDuration() - this.getCurrentTime();
      let timeshiftData = {
        backward: isBackward,
        // Si es negativo o no, se verifica en video/component, quien es quien decide
        // si se va o no a pgm o solo hace seek sobre el actual playing
        seektime: this.state.channelInfo.timeshiftAllowed - this.state.timeshiftTime,
        maxtimeshiftallowed: this.state.channelInfo.timeshiftAllowed,
        timeshiftDelay
      };

      this.updateCurrentTimeUI(this.getCurrentTime());
      this.timerTimeshitDelayId = setTimeout(() => {
        this.timerTimeshitDelayId = null;
        this.performTimeshift(timeshiftData);
      }, this.delayTimeshiftSeek);
    }
  }

  async performTimeshift(timeshiftData) {
    // Nueva experiencia
    if (this.useTimeshiftEvent()) {
      this.switchingBetweenEventTimeshift = true;
      logger.debug('PAU> function performTimeshift > ' + this.switchingBetweenEventTimeshift);
      logger.debug('PAU4> ======================== RESET ============================');
      this.state.timeshiftTime = 0; // Reset
      const safeTime = this.getSafeTime(); // FIXME TIMESHIFT se usa el safe time?
      let _begin = timeshiftData.timeshiftEvent.date_begin + safeTime;
      let _end = timeshiftData.timeshiftEvent.date_end;

      if (this.props.doStartOver && Utils.isFunction(this.props.doStartOver)) {
        this.props.doStartOver(
          TvChannelUtil.getLastChannel(),
          _begin,
          _end,
          timeshiftData,
          true
        );
      }
      try {
        if (typeof this.props.onUpdateCurrentTimeshift === 'function') {
          //console.error('PAU> 5 prev onUpdateCurrentTimeshift', this.getCurrentTime());
          // FIXME TIMESHIFT:  onUpdateCurrentTimeshift? ajustar?
          this.props.onUpdateCurrentTimeshift(this.getCurrentTime());
        }
      } catch (error) {
        logger.error('[PS4 TSH] Error on timeshift ', error);
      }
    }
    // Vieja experiencia
    else {
      logger.debug('[PS4 TSH] enter performTimeshift');
      const now = Utils.now();
      const safeTime = this.getSafeTime();
      logger.error(
        '[PS4 TSH] RDGV: now',
        now,
        'getDuration',
        this.getDuration(),
        'getCurrentTime',
        this.getCurrentTime()
      );
      let begin = new Dates(Utils.now())
        .subtract(this.getDuration() - this.getCurrentTime() + safeTime, 'seconds')
        .toDate();
      begin = this.getDuration() - this.getCurrentTime() > 0 ? begin : null;
      logger.error('[PS4 TSH] RDGV: begin pgm', begin);
      if (this.props.doTimeshift && Utils.isFunction(this.props.doTimeshift)) {
        this.props.doTimeshift(TvChannelUtil.getLastChannel(), begin, timeshiftData);
      }

      try {
        if (typeof this.props.onUpdateCurrentTimeshift === 'function') {
          logger.error(
            '[PS4 TSH] RDGV prev onUpdateCurrentTimeshift',
            this.getCurrentTime()
          );
          this.props.onUpdateCurrentTimeshift(this.getCurrentTime());
        }
      } catch (error) {
        logger.error('[PS4 TSH] Error on timeshift ', error);
      }
    }
  }

  getSafeTime() {
    const timeshiftMetadata = Utils.getApaMetadataKey('epg_event_safe_time', '{}', 'timeshift');

    if (timeshiftMetadata) {
      return timeshiftMetadata.start;
    }else{
      return 0;
    }
  }

  doSeek(newSecs, currentTime) {
    // MANDANDO METRICAS AL DASHBOARD
    logger.debug(
      '[PlayerControls] doSeek  ' + '-newSecs ' + newSecs,
      '- currentTime ' + currentTime
    );
    this.seekBarInterval.stop();
    this.seekBarInterval.start();
    this.isMoving = true;
    this.seekTotalTime = newSecs;
  }

  showSprites() {
    if (
      this.shouldSpriteShow &&
      !this.isTrailer() &&
      !this.isLive() &&
      !store.getState().user.isAnonymous
    ) {
      this.spriteShown = 'visible';
    }
  }

  hideActionBar() {
    let estate = {};
    estate.actionBar = {
      isVisible: false,
      title: '',
      channel: '',
      event: {}
    };

    this.setState(estate, () => {
      this.hide();
    });
  }

  hideActionBarAfterZapping = ()=> {
    if(this.state.actionBar && this.state.actionBar.isVisible){
      const estate = {};
      estate.actionBar = {
        isVisible: false,
        title: '',
        channel: '',
        event: {}
      };
      this.setState(estate);
    }
  }

  hideSprites() {
    this.spriteShown = 'hidden';
  }

  setOperatorsSeek(values) {
    this.valuesSeek = { ...values };
  }

  getOperatorsSeek() {
    return this.valuesSeek;
  }

  sendFowardRewindSeek() {
    const { isBackward, seekTime } = this.getOperatorsSeek();

    if (isBackward && (seekTime === 15 || seekTime === 10)) {
      TrackerManager.rewind(this.player.getCurrentTime());
    } else if (!isBackward && (seekTime === 15 || seekTime === 10)) {
      TrackerManager.foward(this.player.getCurrentTime());
    }
  }

  calculateFinalSeekTime(isBackward, seekTime) {
    // MANDANDO METRICAS AL DASHBOARD necesita refactorizado...
    this.showSprites(this.canShowSprites());
    logger.debug(
      'Vemos los nuevos tiempos que se tienen en el player  -isBackward - seekTime ',
      isBackward,
      seekTime
    );
    this.setOperatorsSeek({ isBackward, seekTime });
    this.show();
    logger.debug('Playerinterval calculateFinalSeekTime this.seekTime> ' + this.seekTime);
    let secs = isBackward ? -seekTime : seekTime;
    let curTime = this.getCurrentTime();
    if (this.seekInPause) {
      curTime = this.seekInPause;
    }
    let newSecs = curTime + (this.seekTime += secs);
    if (newSecs < 0) {
      newSecs = 0;
    }
    if (newSecs > this.duration) {
      newSecs = this.duration - 1;
    }
    logger.debug(
      '[PlayerControls] calculateFinalSeekTime',
      '\nisBackward ' + isBackward,
      '\nnewSeekTime ' + seekTime,
      '\nseekTime ' + this.seekTime,
      '\nnewSecs ' + newSecs,
      '\ncurTime ' + curTime
    );
    this.updateCurrentTimeUI(newSecs);
    this.updateSprite(newSecs);
    this.doSeek(newSecs, curTime);
    this.hideSprites();
  }

  focus(selector) {
    if (Utils.isModalHide()) {
      return window.SpatialNavigation.focus(selector);
    }
  }

  focusSlider() {
    const resultFocus = this.focus('.player-ui-progress-bar-ball');
    if(!resultFocus){
      this.focusPlayButton();
    }
  }

  focusPlayButton() {
    // [TIZEN][resetPlayerStatus] If an key is pressed isFocusButton = TRUE
    this.isFocusButton = true;
    this.focus('.player-main-button');
  }

  focusBackwardButton() {
    this.focus('#backward');
  }

  focusForwardButton() {
    this.focus('#forward');
  }

  focusMiniEpg(sendMoveSpatial) {
    let currentEventId = Utils.idEventCurrent(
      this.epgInPlayerControl,
      this.currentHorizontalIndex
    );
    logger.debug('FOCUS MINI', currentEventId);
    Utils.isMiniEPGOpen() &&
    window.SpatialNavigation.focus(currentEventId || '.epg-main .focusable');
    if (sendMoveSpatial && sendMoveSpatial.currentKey) {
      Utils.moveSpatial(sendMoveSpatial.currentKey);
    }
  }

  onFocus(e) {
    logger.debug('Playercontrols onFocus method');
    this.resetPlayerStatus(e);
    this.show();
  }

  resetPlayerStatus(e) {
    // [TIZEN] This method is add for Tizen transition between an External App (e.g Youtube) & Clarovideo
    const platf = Device.getDevice().getPlatform();

    if (platf === 'tizen' && !this.state.playing && !this.isLive() && !this.isFocusButton) {
      // The state only changes when no key is pressed
      e &&
      e.detail &&
      !e.detail.direction &&
      this.setState({
        playing: true
      });
    }
  }

  onFocusMove(e) {
    const { direction } = e.detail;
    switch (direction) {
      case 'down':
        e.preventDefault();
      case 'up':
        if (this.isInTrickMode) {
          e.preventDefault();
        }
      default:
    }
  }

  getLinks() {
    return getLinksFromNavConfiguration();
  }

  showControlsByStremContentType = () => {
    const streamContentType = this.props.streamContentType();
    switch (streamContentType) {
      case constant.AAF_CONTENT_IS_CATCHUP:
      case constant.AAF_CONTENT_IS_STARTOVER:
      case constant.AAF_CONTENT_IS_NPVR:
        this.show();
        this.focusPlayButton();
        return true;
      default:
        return false;
    }
  };

  keyPressHandler(e) {
    if (EpgPersistence.isEnabled() && Utils.isFullEpgPersistanceOpen()) {
      return;
    }
    if (!Utils.isModalHide()) {
      return;
    }
    logger.debug('Listening [PlayerControls] keyPressHandler');
    if (LayersControl.isUXVisible()) return;
    const modal = document.getElementsByClassName('modal-overlay');
    const streamContentType = this.props.streamContentType();
    const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
    logger.debug('Enter to Listening [PlayerControls] keyPressHandler, currentKey:', currentKey);

    let _persistentMiniIsVisible = false;

    switch (currentKey) {
      case 'INFO':
        let user = store.getState().user;
        let isOTTGuy =
          !user ||
          !user.paymentMethods ||
          (user.paymentMethods &&
            !user.paymentMethods.hubcorporativofijogate &&
            !user.paymentMethods.hubfijovirtualgate &&
            !user.paymentMethods.clarocolombiagate);
        if (!isOTTGuy) {
          /* quitando funcionalidad de boton info para usuarios que no son ott
           console.log('Listening PlayerControls => Handle INFO ', currentKey);
           const lastChannel = TvChannelUtil.getLastChannel();
           this.props.goToCard('/epg/' + lastChannel);
           */
        }

        //Mostrar miniguia
        if (this.isVisible) {
          this.hide();
        } else {
          this.showMiniEPG(e);
        }
        break;
      case 'BLUE':
        if (this.enableButton('blue') && !EpgPersistence.isEnabled()) {
          if (this.isVisible) {
            let eventId = false;
            let event = {};
            const isActionBarVisible = this.state.actionBar.isVisible;
            const currentState = this.setState;
            let epgChannelItemId = null;
            const epgChannelItemIdQs = document.querySelector('.epg-channel-item-id');

            if (epgChannelItemIdQs) {
              epgChannelItemId = epgChannelItemIdQs.innerText;
            } else {
              return;
            }

            let channel = this.epgInPlayerControl.data.find(a =>
              a.find(b => b.number == epgChannelItemId)
            );

            if (e.target && e.target.dataset) {
              eventId = e.target.dataset.eventId;
            }

            if (eventId && channel && channel[0]) {
              let events = channel[0].events[this.currentHorizontalIndex];
              event = events.find(b => b.id == eventId);
              if (!event) {
                let newEvents = channel[0].events.find(a =>
                  a.find(b => b.id == eventId)
                );
                event = newEvents.find(b => b.id == eventId);
              }
            }

            if (
              isActionBarVisible ||
              (!isActionBarVisible &&
                e.target &&
                e.target.nodeName &&
                e.target.nodeName === 'A' &&
                e.target.id &&
                e.target.id.includes &&
                e.target.id.includes('event-'))
            ) {
              this.setState(
                {
                  ...currentState,
                  actionBar: {
                    ...currentState.ActionBar,
                    isVisible: !isActionBarVisible,
                    title: e.target ? e.target.innerText : '',
                    channel: epgChannelItemId ? epgChannelItemId : '',
                    event
                  }
                },
                () => {
                  if (!isActionBarVisible) {
                    setTimeout(() => {
                      window.SpatialNavigation.focus(
                        '.action-bar.container .action-bar-wrapper:first-child a'
                      );
                    }, 500);
                  }
                }
              );
            }

            return;
          }
        }
        if (this.isVod()) {
          //Se quita funcionalidad a los botones de colores en VOD
          return;
        }
        if (!this.isLive()) {
          this.toggleControlsVod();
        }
        break;
      case 'YELLOW':
        if (this.isVisible && this.state.actionBar.isVisible) {
          //Muestra la Miniguia estando en el ActionBAr
          this.setState(
            (state, props) => ({
              ...state,
              actionBar: {
                ...state.ActionBar,
                isVisible: false,
                title: '',
                channel: '',
                event: {}
              }
            }),
            () => {
              this.showMiniEPG(e, currentKey);
            }
          );
          return;
        }
        if (this.showControlsByStremContentType()) {
          return;
        }

        if (this.isVod()) {
          //Se quita funcionalidad a los botones de colores en VOD
          return;
        }
        if (!this.isLive()) this.toggleControlsVod();
        break;
      case 'GREEN':
        if (this.isVod()) {
          //Se quita funcionalidad a los botones de colores en VOD
          return;
        }
        if (!this.isLive()) this.showLangModal();
        break;
      case 'RED':
        if (this.isVod()) {
          //Se quita funcionalidad a los botones de colores en VOD
          return;
        }
        if (this.isLive()) {
          this.sendMetric('buscar');
          this.props.goToCard('/search');
        } else {
          this.toggleControlsVod();
        }
        break;
      case 'FWD':
        this.showControls();
        this.show();

        this.forward();
        if (!this.isLive()) this.closeModalLang();
        break;
      case 'RWD': //backward
        _persistentMiniIsVisible = this.persistentMiniIsVisible();
        this.showControls();
        this.show();
        // Si la tecla de RWD fue presionada cuando la mini estaba visible, entonces se oculta
        if (_persistentMiniIsVisible) {
          HideMiniObserver.fire();
        }
        this.backward();
        if (!this.isLive()) this.closeModalLang();
        logger.debug('PLAYER');
        break;
      case 'NEXT_SKIP':
        this.show();
        this.showControls();
        this.stepForward();
        logger.debug('NEXT_SKIP BUTTON');
        break;
      case 'PREV_SKIP':
        this.show();
        this.showControls();
        this.stepBackward();
        logger.debug('PREV_SKIP BUTTON');
        break;
      case 'PLAYPAUSE': // for new models samsung tizen small control
      case 'PAUSE': // PAUSE / PLAY
      case 'PLAY': // PLAY || PAUSE / PLAY
        _persistentMiniIsVisible = this.persistentMiniIsVisible();
        this.onPlayPausekeyPressHandler(e);
        if (_persistentMiniIsVisible) {
          HideMiniObserver.fire();
        }
        break;
      case 'STOP': //PARAR - INICIAR
        if (!this.isLive()) {
          //this.show();
          //this.seek(0);
          this.back(); //regresa a la ficha solo para vod
          this.closeModalLang();
        }
        break;
      case 'REC': //RECORD
        if (this.recordingsEnabled && (!this.isLive() || this.useTimeshiftEvent())) {
          this.show();
          this.record();
        }
        break;
      case 'SUB_AUD': //SUBTITLES
        if (this.isLive()  ||
          streamContentType === constant.AAF_CONTENT_IS_CATCHUP ||
          (isAndroidDevice() && streamContentType === constant.AAF_CONTENT_IS_NPVR)) {
          if (
            MultipleLangLive.isEnabled() &&
            MultipleLangLive.isGroupIdEnabled(
              this.props.epgGroupId,
              this.getStreamType()
            )
          ) {
            this.showLangModal();
          } else {
            this.showSubtitleNotification();
          }
        } else if (streamContentType === constant.AAF_CONTENT_IS_VOD) {

          if(this.isTrailer()) {
            e.preventDefault();
            e.stopPropagation();
            return;
          }

          this.showLangModal();

        } else if (
          streamContentType === constant.AAF_CONTENT_IS_TIMESHIFT ||
          streamContentType === constant.AAF_CONTENT_IS_STARTOVER
        ) {
          return;
        }
        break;
      case 'GUIDE':
        if (this.props.isChangingChannel()) {
          return;
        }

        if (this.isLive()) {
          this.props.handleFullEpg('GUIDE');
        } else if (this.isVod()) {
          e.preventDefault();
          e.stopPropagation();
          logger.debug('GUIDE btn in VOD should not be handled');
        } else {
          /* TODO nagratv hardcode */
          this.props.goToCard(`/node/${this.getLinks().clarotv}?param=channels`);
        }
        break;
      case 'BACK':
        e.preventDefault();
        e.stopPropagation();

        if (this.isVisible && this.state.actionBar.isVisible) {
          //Muestra la Miniguia estando en el ActionBAr
          this.setState(
            (state, props) => ({
              ...state,
              actionBar: {
                ...state.ActionBar,
                isVisible: false,
                title: '',
                channel: '',
                event: {}
              }
            }),
            () => {
              this.showMiniEPG(e, currentKey);
            }
          );
          return;
        }

        // Para música
        if (
          this.props.type === playerConstant.AUDIO ||
          this.props.type === playerConstant.RADIO
        ) {
          this.back();
          store.dispatch({ type: HIDE_MODAL });
          this.props.hideEpgOutside();
        }
        // Para video
        else {
          if (this.isVisible) {
            this.hide();
          } else {
            this.back();
            this.props.hideEpgOutside();
          }
        }
        break;
      case 'RIGHT':
      case 'LEFT':
      case 'UP':
      case 'DOWN':
        this.showMiniEPG(e, currentKey);
        break;
      case 'MOSAIC':
        e.stopPropagation();
        if (this.isLive()) {
          if (Utils.isFullEpgOpen()) {
            this.props.handleFullEpg('MOSAIC');
          }
          this.props.handleFullEpg('MOSAIC');
        } else if (this.isVod()) {
          e.preventDefault();
          e.stopPropagation();
          logger.debug('MOSAIC btn in VOD should not be handled');
        }
        break;
      case 'OK':
        // TODO add here all methods that will have similar functionality
        if (
          e.target.id === 'backward' ||
          e.target.id === 'forward' ||
          e.target.id === 'stepBackward' ||
          e.target.id === 'stepForward'
        ) {
          e.preventDefault();
          e.stopPropagation();
          if (e.target.id === 'backward') {
            this.backward();
          }
          if (e.target.id === 'stepBackward') {
            this.stepBackward();
          }
          if (e.target.id === 'forward') {
            this.forward();
          }
          if (e.target.id === 'stepForward') {
            this.stepForward();
          }
        } else if (true && !this.flagSkipIntro) {
          //todo to define a condition to this
          this.showMiniEPG(e, currentKey);
        }
        break;
      case 'CH_UP':
      case 'CH_DOWN':
        if(Utils.modalType() === MODAL_INACTIVITY){
          e.preventDefault();
            e.stopPropagation();
          return;
        }
        if (!this.isLive()) {
          break;
        }
        if (this.isVisible && this.state.actionBar.isVisible) {
          //Muestra la Miniguia estando en el ActionBAr
          this.setState(
            (state, props) => ({
              actionBar: {
                ...state.ActionBar,
                isVisible: false,
                title: '',
                channel: '',
                event: {}
              }
            }),
            () => {
              if (Utils.choiceBehaviorChannelChange()) {
                this.showMiniEPG(e, currentKey);
              }
            }
          );
        } else {
          if (Utils.choiceBehaviorChannelChange()) {
            this.showMiniEPG(e, currentKey);
          }
        }
        break;
      case 'ZERO':
      case 'ONE':
      case 'TWO':
      case 'THREE':
      case 'FOUR':
      case 'FIVE':
      case 'SIX':
      case 'SEVEN':
      case 'EIGHT':
      case 'NINE':
        store.dispatch(navigateFrom('Number'));
        if (this.props.type === 'live' && modal.length === 0) {
          if (!this.props.isChangingChannel() && !this.props.checkStatusEPG) {
            this.handleChannelChange(e, this.codeToVal.getKeyValue(currentKey));
          }
        }
        break;
      default:
        break;
    }
  }

  persistentMiniIsVisible() {
    let persistentMiniIsVisible = false;
    if (EpgPersistence.isEnabled()) {
      const className = this.refs.container.className;
      persistentMiniIsVisible =
        className.includes('show-mini-epg') && !className.includes('hide-controls');
    }

    return persistentMiniIsVisible;
  }

  showSubtitleNotification() {
    const notificationProps = {
      show: true,
      title: Translator.get(
        'live_audio_subtitle_not_available_title',
        '¡Audio y subtitulos!'
      ),
      msg: Translator.get('live_audio_subtitle_not_available_msg', 'Función no disponible.'),
      apaAsset: 'live_audio_subtitle_not_available_icon',
      type: 'message'
    };

    store.dispatch(showNotification(notificationProps));
  }

  onPlayPausekeyPressHandler() {
    const streamContentType = this.props.streamContentType();

    switch (streamContentType) {
      case constant.AAF_CONTENT_IS_TV:
        logger.debug(' >| LIVE');
        this.playPauseButtonControl();
        break;
      case constant.AAF_CONTENT_IS_STARTOVER:
      case constant.AAF_CONTENT_IS_CATCHUP:
      case constant.AAF_CONTENT_IS_NPVR:
        logger.debug(' >| START OVER');
        this.playPauseButtonControl();
        break;
      case constant.AAF_CONTENT_IS_VOD:
        //case constant.AAF_CONTENT_IS_CATCHUP:
        logger.debug(' >| VOD');
        this.show();
        this.showControls();
        this.closeModalLang();
        this.isPlay = !this.isPlay;
        if (this.isPlay) {
          this.play();
        } else {
          this.pause();
        }
        break;
      default:
        logger.debug(' >| Stream no controlado', streamContentType);
    }
    this.forceStopAutoHide = false;
    this.verifySetAutoHide();
  }

  showMiniEPG(e, currentKey) {
    if (!EpgPersistence.isEnabled() && this.props.isChangingChannel()) {
      return;
    }
    const modal = document.getElementsByClassName('modal-overlay');

    if (modal.length === 0) {
      if (
        !this.isVisible &&
        this.props.style &&
        this.props.style.display == 'block' &&
        !this.isLive()
      ) {
        e.preventDefault();
        e.stopPropagation();
        this.show();
        window.SpatialNavigation.pause(); //to avoid click on play pause button when player controls are showed
        this.focusPlayButton();
        setTimeout(() => {
          window.SpatialNavigation.resume();
        }, 300);
      } else this.show(currentKey);
    }
  }

  playPauseButtonControl = () => {
    if (Utils.getPlayPauseButtonToggle().enable && !this.isVisible) {
      this.showControls();
      this.toggleControlsVod();
    }

    if (this.isVisible && this.refs.container) {
      const className = this.refs.container.className;
      if (className.indexOf('show-mini-epg') > -1) {
        this.showControls();
      }
      if (this.state.playing) {
        if (
          this.hasTimeshift() ||
          this.props.streamContentType() === constant.AAF_CONTENT_IS_CATCHUP ||
          this.props.streamContentType() === constant.AAF_CONTENT_IS_NPVR
        ) {
          this.isPlay = false;
          if (this.props.streamContentType() === constant.AAF_CONTENT_IS_TV) {
            this.liveWasPause = true;
          }
          this.pause();
        }
      } else {
        if (
          this.hasTimeshift() ||
          this.props.streamContentType() === constant.AAF_CONTENT_IS_CATCHUP ||
          this.props.streamContentType() === constant.AAF_CONTENT_IS_NPVR
        ) {
          this.isPlay = true;
          if (this.props.streamContentType() === constant.AAF_CONTENT_IS_TV) {
            this.liveWasPause = false;
          }
          this.play();
        }
      }
    }
  };

  handleChannelChange(e, number) {
    e.preventDefault();
    e.stopPropagation();

    if (this.props.isChangingChannel()) {
      return;
    }
    this.show();
    if (this.timerDelayChannelChange) clearTimeout(this.timerDelayChannelChange);
    this.lastNumberPressed = `${this.lastNumberPressed}${number}`;
    const currentLength = this.lastNumberPressed.length;

    if (
      this.refs.channelNumber &&
      this.refs.container &&
      currentLength <= this.maxLenNumberChannel
    ) {
      const className = this.refs.container.className;
      this.refs.container.className = `${className.replace(' hide-controls', '')}`;
      this.refs.channelNumber.innerHTML = this.lastNumberPressed;
      this.refs.channelNumber.className = 'player-ui-channel-number';
    }

    this.timerDelayChannelChange = setTimeout(() => {
      document.dispatchEvent(
        new CustomEvent('manage_action_bar', {
          detail: { visible: false, data: null, event: null }
        })
      );
      this.channelChangeHandler(this.lastNumberPressed, this.props.linealChannels);
    }, this.delayChannelChange);
  }

  channelChangeHandler(newChannel, linealChannelsPurchased) {
    /**
     * Numeric channel change RCU, parse number channel to compare
     * '10' == '10' and not '010' == '10'
     */
    if(newChannel.length > 0) {
      if(newChannel.substring(0, 1) == '0') {
        newChannel = Number.parseInt(newChannel);
      }
    }

    this.timerDelayChannelChange = null;
    new ChannelSingleton().getChannels().then(channels => {
      let channelIndex = channels.findIndex(channel => channel.id == newChannel);
      const channel =
        channelIndex >= 0
          ? channels[channelIndex]
          : Utils.getClosestChannel(parseInt(newChannel), channels);

      if (channel) {
        if (channel.group_id !== TvChannelUtil.getLastChannel()) {
          let channelIndex = channels.findIndex(channel => channel.id == newChannel);
          let paywayTem = this.props.linealChannels.map(x => x.id);
          let paywayIds = channels
            .filter(x => paywayTem.indexOf(x.group_id) != -1)
            .map(x => x.group_id);
          if (channelIndex >= 0) {
            if (paywayIds.indexOf(channels[channelIndex].group_id) == -1) {
              this.refs.channelNumber.innerHTML = '';
              this.refs.channelNumber.className = '';
              this.resetChannelNumberId = null;
              this.lastNumberPressed = '';
              this.playerStreamingUtils.checkSusc(null, channel.group_id);
              return;
            } else {
              this.props.hideOnlyMini(
                paywayIds.indexOf(channels[channelIndex].group_id)
              );
            }
          } else {
            channels = channels.filter(x => paywayIds.indexOf(x.group_id) > -1);
            const channel = Utils.getClosestChannel(parseInt(newChannel), channels);
            this.props.hideOnlyMini(paywayIds.indexOf(channel.group_id));
          }
        }
        if (this.refs.channelNumber) {
          this.refs.channelNumber.innerHTML = this.lastNumberPressed;
          this.resetChannelNumberId = setTimeout(() => {
            this.refs.channelNumber.innerHTML = '';
            this.refs.channelNumber.className = '';
            this.resetChannelNumberId = null;
            this.lastNumberPressed = '';
          }, this.delayChannelChange / 2);
        }
      }
    });
  }

  getStreamType() {
    return this.props.streamType;
  }

  setTimer = () => {
    if (this.props.autoHide) {
      this.verifySetAutoHide();
    }
  };

  startAutoHideTimer = () => {
    const autoHideMiniEpgSeconds = Utils.miniFullEpgAutoHideSeconds(
      'mini_epg_auto_hide_seconds',
      7
    );
    if (this.isLive()) {
      if (typeof autoHideMiniEpgSeconds === 'number') {
        this.settings.inactivityTime = autoHideMiniEpgSeconds;
      }
    }
    const time = this.settings.inactivityTime ? this.settings.inactivityTime * 1000 : 20000;
    if (!this.timer) {
      this.timer = setInterval(this.hide, time);
    }
  };

  stopAutoHideTimer = () => {
    clearInterval(this.timer);
    this.timer = null;
  };

  shouldAutoHideStops = () => {
    const steamContentType = this.props.streamContentType();
    logger.debug('[PlayerControls] shouldAutoHideStops streamContentType: ' + steamContentType);
    switch (steamContentType) {
      case constant.AAF_CONTENT_IS_CATCHUP:
      case constant.AAF_CONTENT_IS_STARTOVER:
      case constant.AAF_CONTENT_IS_NPVR:
      case constant.AAF_CONTENT_IS_TV:
        return true;
      default:
        return false;
    }
  };

  verifySetAutoHide = (skipPlayingValidation = false) => {
    this.stopAutoHideTimer();
    logger.debug('[PlayerControls] verifySetAutoHide isPlaying?: ' + this.isPlay);
    if (
      this.shouldAutoHideStops() &&
      (skipPlayingValidation || !this.isPlay || this.forceStopAutoHide) &&
      !Utils.MiniEpgPersistanceOpen()
    ) {
      logger.debug('[PlayerControls] verifySetAutoHide lets stopAutoHide');
      return;
    } else {
      logger.debug('[PlayerControls] verifySetAutoHide lets startAutoHideTimer');
      this.startAutoHideTimer();
    }
  };

  isLive() {
    return this.props.type.toLowerCase() === 'live';
  }

  isVod() {
    return this.props.type.toLowerCase() === 'default' || 'serie';
  }

  isTrailer() {
    return store.getState().player.ispreview;
  }

  hasTimeshift() {
    if (this.state && this.state.timeshiftEventInfo) {
      //console.log('PAU> PlayerControls > hasTimeshift > this.state.timeshiftEventInfo NO es null');
      return (
        this.state.timeshiftEventInfo.event &&
        !isNaN(this.state.timeshiftEventInfo.event.max_timeshift)
      );
    } else {
      //console.log('PAU> PlayerControls > hasTimeshift > this.state.timeshiftEventInfo SÍ es null');
      return this.timeshiftAllowed && this.timeshiftAllowed > 0 ? true : false;
    }
  }

  /**
   * Toggle main button between play and pause
   * @returns {ReactElement}
   */
  getPlayButton(buttons) {
    const button = this.state.playing ? buttons['pause'] : buttons['play'];
    if (button && !this.state.playing) {
      setTimeout(() => {
        const domsButtons = Array.from(document.querySelectorAll('.player-main-button'));
        domsButtons &&
        Array.isArray(domsButtons) &&
        domsButtons.map((btn, index) => {
          btn.removeEventListener('sn:focused', this.onFocus);
          btn.removeEventListener('sn:willmove', this.onFocusMove);
          btn.addEventListener('sn:focused', this.onFocus);
          btn.addEventListener('sn:willmove', this.onFocusMove);
        });
      }, 100);
    }
    return button;
  }

  getDefaultButtons() {
    let favoriteImageSrc,
      isShuffle,
      isRepeat = null;
    if (this.props.type === playerConstant.AUDIO || this.props.type === playerConstant.RADIO) {
      const {isSongFavorite} = this.state;
      const opcFavorite = this.props.opcFavorite ? Asset.get('player_controls_favorited_selected') : Asset.get('player_controls_favorited');
      favoriteImageSrc = Utils.isNullOrUndefined(isSongFavorite) ? opcFavorite : (isSongFavorite ? Asset.get('player_controls_favorited_selected') : Asset.get('player_controls_favorited'));

      isShuffle = this.props.opcShuffle
        ? Asset.get('player_controls_random_selected')
        : Asset.get('player_controls_random');
      isRepeat =
        this.props.opcRepeat === 2
          ? Asset.get('player_controls_repeat_selected')
          : this.props.opcRepeat === 1
          ? Asset.get('player_controls_repeat_one_selected')
          : Asset.get('player_controls_repeat');
    }

    //time shift buttons
    let opacityClass = 'focusable';
    this.disableTS = false;

    // FIXME TIMESHIFT verificar por el catchup
    if (this.isLive()) {
      // Si timeshift event info viene con valor significa que está
      // habilitada la nueva experiencia de timeshift
      if (this.state.timeshiftEventInfo) {
      }

      let timAllow = '0';
      if (
        this.state.channelInfo &&
        Utils.isNotNullOrNotUndefined(this.state.channelInfo.timeshiftAllowed)
      ) {
        timAllow = this.state.channelInfo.timeshiftAllowed;
      } else {
        if (
          this.props.channelInfo &&
          Utils.isNotNullOrNotUndefined(this.props.channelInfo.timeshiftAllowed)
        ) {
          timAllow = this.props.channelInfo.timeshiftAllowed;
        }
      }
      this.disableTS = timAllow == '0';
      opacityClass = this.disableTS ? 'btnopacity' : 'focusable';
    }

    const isPs4 = device_platform === 'ps4' ? 'noshadow' : null;
    const mainClassName = `player-ui-button action focusable ${isPs4}`;
    const mainClassOpacity = `player-ui-button action ${opacityClass} ${isPs4}`;

    let mainClassOpacityLang = mainClassOpacity;
    let disableTSLang = this.disableTS;

    if (this.isLive() || this.props.streamContentType() === constant.AAF_CONTENT_IS_CATCHUP) {
      if (MultipleLangLive.isEnabled()) {
        mainClassOpacityLang = mainClassOpacityLang.replace('btnopacity', 'focusable');
        disableTSLang = false;

        if (
          !MultipleLangLive.isGroupIdEnabled(this.props.epgGroupId, this.getStreamType())
        ) {
          mainClassOpacityLang = mainClassOpacityLang.replace('focusable', 'btnopacity');
          disableTSLang = true;
        }
      }
    }

    const hasNoTimeshift = this.isLive() && !this.hasTimeshift();
    const timeshiftStyle = hasNoTimeshift ? { opacity: '0.2' } : null;
    const timeshiftOnClick = () => {};
    const defaultButtons = {
      back: (
        <a
          href="javascript:void(0)"
          key="back"
          className={`${mainClassName} player-secondary-button`}
          onClick={this.back}
        >
          <img
            src={Asset.get('player_controls_back_icon')}
            alt="player_controls_back_icon"
          />
        </a>
      ),
      favorite: (
        <a
          href="javascript:void(0)"
          key="favorite"
          id="favoriteBtn"
          className={`${mainClassName}`}
          onClick={this.onFavoriteSong}
          alt={this.props.opcFavorite}
        >
            <img src={`${favoriteImageSrc}`} alt="isFavorite" />
        </a>
      ),
      replay: (
        <a
          href="javascript:void(0)"
          key="replay"
          className={`${mainClassOpacity}`}
          onClick={this.disableTS ? null : () => this.fastBackward()}
        >
          <img
            src={Asset.get('player_controls_replay_icon')}
            alt="player_controls_replay_icon"
          />
        </a>
      ),
      previewSong: (
        <a
          href="javascript:void(0)"
          key="previewSong"
          className={`${mainClassName}`}
          onClick={() => this.previewSong()}
        >
          <img
            src={Asset.get('player_controls_step_backward_icon')}
            alt="player_controls_step_backward_icon"
          />
        </a>
      ),
      fastBackward: (
        <Button
          key="fastBackward"
          className={'player-ui-button ' + opacityClass}
          iconClassName="fa fa-fast-backward"
          onClick={this.disableTS ? null : this.fastBackward}
        />
      ),
      stepBackward: (
        <a
          href="javascript:void(0)"
          id="stepBackward"
          key="stepBackward"
          className={`${mainClassOpacity}`}
        >
          <img
            src={Asset.get('player_controls_step_backward_icon')}
            alt="player_controls_step_backward_icon"
          />
        </a>
      ),
      backward: (
        <a
          href="javascript:;"
          id="backward"
          key="backward"
          className={`${mainClassOpacity}`}
        >
          <img src={Asset.get('player_controls_backward_icon')} />
          <div id="trickmode_backward"></div>
        </a>
      ),
      play: (
        <a
          href="javascript:void(0)"
          key="play"
          className={`${mainClassOpacity} player-main-button`}
          onClick={this.disableTS ? null : this.play}
        >
          <img
            src={Asset.get('player_controls_play_icon')}
            alt="player_controls_play_icon"
          />
        </a>
      ),
      pause: (
        <a
          href="javascript:void(0)"
          key="pause"
          className={`${mainClassOpacity} player-main-button`}
          onClick={this.disableTS ? null : this.pause}
        >
          <img
            src={Asset.get('player_controls_pause_icon')}
            alt="player_controls_pause_icon"
          />
        </a>
      ),
      forward: (
        <a
          href="javascript:;"
          id="forward"
          key="forward"
          className={`${mainClassOpacity}`}
          // data-sn-up=".player-ui-progress-bar-ball"
        >
          <img src={Asset.get('player_controls_forward_icon')} />
          <div id="trickmode_forward"></div>
        </a>
      ),
      stepForward: (
        <a
          href="javascript:void(0)"
          id="stepForward"
          key="stepForward"
          className={`${mainClassOpacity}`}
        >
          <img
            src={Asset.get('player_controls_step_forward_icon')}
            alt="player_controls_step_forward_icon"
          />
        </a>
      ),
      fastForward: (
        <Button
          key="fastForward"
          className="player-ui-button"
          iconClassName="fa fa-fast-forward"
          onKeyPress={this.fastForward}
        />
      ),
      next: (
        <a
          href="javascript:void(0)"
          key="next"
          className={`${mainClassName}`}
          onClick={this.disableTS ? null : () => this.fastForward()}
          data-sn-up=".player-ui-progress-bar-ball"
        >
          <img
            src={Asset.get('player_controls_next_icon')}
            alt="player_controls_next_icon"
          />
        </a>
      ),
      nextSong: (
        <a
          href="javascript:void(0)"
          key="next"
          className={`${mainClassName}`}
          onClick={() => this.nextSong()}
        >
          <img
            src={Asset.get('player_controls_step_forward_icon')}
            alt="player_controls_step_forward_icon"
          />
        </a>
      ),
      lang: (
        <a
          href="javascript:void(0)"
          key="lang"
          className={`${mainClassOpacityLang}`}
          onClick={this.disableTSLang ? null : () => this.showLangModal()}
          data-sn-up=".player-ui-progress-bar-ball"
        >
          <img
            src={Asset.get('player_controls_lang_icon')}
            alt="player_controls_lang_icon"
          />
        </a>
      ),
      seasons: (
        <a
          href="javascript:void(0)"
          key="seasons"
          ref="seasons"
          style={{ display: 'none' }}
          className={`${mainClassName}`}
          onClick={this.showSeasonsModal}
          data-sn-up=".player-ui-progress-bar-ball"
        >
          <img
            src={Asset.get('player_controls_seasons_icon')}
            alt="player_controls_seasons_icon"
          />
        </a>
      ),
      epg: (
        <a
          href="javascript:void(0)"
          key="epg"
          className={`${mainClassName}`}
          onClick={this.showFullEpg}
        >
          <img
            src={Asset.get('player_controls_epg_icon')}
            alt="player_controls_epg_icon"
          />
        </a>
      ),
      repeat: (
        <a
          href="javascript:void(0)"
          id="repeatBtn"
          key="epg"
          className={`${mainClassName}`}
          onClick={this.doRepeat}
        >
          <img src={`${isRepeat}`} alt="isRepeat" />
        </a>
      ),
      shuffle: (
        <a
          href="javascript:void(0)"
          id="shuffleBtn"
          key="shuffle"
          className={`${mainClassName}`}
          onClick={this.doShuffle}
        >
          <img src={`${isShuffle}`} alt="isShuffle" />
        </a>
      )
    };

    if (this.recordingsEnabled) {
      defaultButtons.record = (
        <a
          href="javascript:void(0)"
          key="record"
          className={`${mainClassOpacity}`}
          onClick={this.disableTS ? null : this.record}
        >
          <img
            src={Asset.get('player_controls_record_icon')}
            alt="player_controls_record_icon"
          />
        </a>
      );
    }

    if (this.handleSkipIntro) {
      let text = Translator.get('skip_intro_player', 'Omitir intro');
      defaultButtons.skipIntro = (
        <a
          href="javascript:void(0)"
          key="skipIntro"
          id="skipIntro"
          className={`focusable focusable-skip skip-control-btn action`}
          onClick={this.onSkipIntro}
          data-sn-down=".player-ui-progress-bar-ball"
        >
          {text}
        </a>
      );
    }

    return defaultButtons;
  }

  setMovementFocusRulesOnLimitButtons(){
    const buttons = Array.from(document.querySelectorAll('.player-ui-button'));
    buttons.map((button, index) => {
      if (index === 0) {
        if (document.getElementById('btn-hide') !== null) {
          button.setAttribute('data-sn-left', '#btn-hide');
        } else {
          button.setAttribute('data-sn-left', '.player-ui-button.focusable:first-child');
        }
      }else if (index === buttons.length - 1) {
        button.setAttribute('data-sn-right', '.player-ui-button.focusable:last-child');
      }else{
        button.removeAttribute('data-sn-right');
      }

      button.removeEventListener('sn:focused', this.onFocus);
      button.removeEventListener('sn:willmove', this.onFocusMove);

      button.addEventListener('sn:focused', this.onFocus);
      button.addEventListener('sn:willmove', this.onFocusMove);
    });
  }

  isTrailer() {
    const resParams = this.props.playingResolvedParams();

    return resParams && resParams.isTrailer;
  }

  getVisibleButtons() {
    let buttonsType = this.settings.types.hasOwnProperty(this.props.type)
      ? this.props.type
      : 'default';
    if(buttonsType !== this.buttonsType){
      if(this.buttonsType === 'transition'){
        this.setMovementFocusRulesOnLimitButtons();
        this.buttonsType = buttonsType;
      }else{
        this.buttonsType = 'transition';
      }
    }
    const buttons = Object.assign({}, this.getDefaultButtons(), this.props.buttons);

    const steamContentType = this.props.streamContentType && this.props.streamContentType();
    logger.debug(
      '[PAUNPVR] PlayerControls > getVisibleButtons > streamContentType: ',
      steamContentType
    );
    logger.debug(
      '[PAUNPVR] PlayerControls > getVisibleButtons > this.props.type: ',
      this.props.type
    );

    let options = this.settings.types.hasOwnProperty(this.props.type)
      ? this.settings.types[this.props.type]
      : this.settings.types.default;

    switch (steamContentType) {
      case constant.AAF_CONTENT_IS_CATCHUP:
        // Verificar por botón de recording, se mantiene o se quita
        const playerState = store.getState().player;
        if (playerState && typeof playerState.event === 'object') {
          if (NpvrUtil.eventIsRecordable(playerState.event)) {
            options = this.settings.types['catchup'];
          }
        }
        break;
        // Trailer
        case constant.AAF_CONTENT_IS_VOD:
          if(this.isTrailer()) {
            options = this.settings.types['trailer'];
          }
        break;
      default:
        break;
    }

    logger.debug('[PAUNPVR] PlayerControls > getVisibleButtons > options: ', options);

    const visible = {};

    if (this.props.type === playerConstant.AUDIO || this.props.type === playerConstant.RADIO) {
      const songType = store.dispatch(checkSongType());
      options =
        songType === playerConstant.AUDIO
          ? this.settings.types.musica
          : songType === playerConstant.RADIO
          ? this.settings.types.radio
          : this.settings.types.musica;
    }

    options.buttons.forEach(name => {
      if (buttons.hasOwnProperty(name)) {
        visible[name] = name === 'play' ? this.getPlayButton(buttons) : buttons[name];
      }
    });
    return visible;
  }

  getSkipIntroButton() {
    const buttons = this.getDefaultButtons();
    return buttons.skipIntro;
  }

  handleActionBar = event_data => {
    if (event_data.detail.visible === true) {
      let eventId = false;
      let event = {};

      let e = event_data.detail.event;
      let data = event_data.detail.data;

      const channelId = e.target.dataset.channelId;
      let channels = data.find(a => a.find(b => b.id === channelId));
      let channel = channels.find(b => b.id === channelId);

      if (e.target && e.target.dataset) {
        eventId = e.target.dataset.eventId;
      }

      if (eventId && channel) {
        let newEvents = channel.events.find(a => a.find(b => b.id === eventId));
        event = newEvents.find(b => b.id === eventId);
      }

      this.props.hideEpgOutside(null);

      let estate = {};
      estate.actionBar = {
        isVisible: true,
        title: e.target.innerText,
        channel: channel.number,
        event
      };

      this.show();
      this.setState(estate);
    } else {
      let estate = {};
      estate.actionBar = {
        isVisible: false,
        title: '',
        channel: '',
        event: {}
      };

      this.setState(estate, () => {
        this.hide();
      });
    }
  };

  /**
   * Add actions to control buttons
   */
  addListeners() {
    ShowPlayerControlsObserver.subscribe(this.show);
    HidePlayerControlsObserver.subscribe(this.hide);
    LetsPlayCatchup.subscribe(this.setTrueLetsPlayCatchup);

    document.addEventListener('manage_action_bar', this.handleActionBar);

    this.focusPlayButton();
    if (this.refs.slider) {
      this.refs.slider.removeEventListener('sn:willmove', this.slide);
      this.refs.slider.addEventListener('sn:willmove', this.slide);
    }
    if (this.refs.container) {
      if (
        navigator.userAgent.toLowerCase().indexOf('opera') !== -1 &&
        (navigator.userAgent.toLowerCase().indexOf('netrange') === -1 || navigator.userAgent.toLowerCase().indexOf('netrangemmh') === -1 ) &&
        Utils.deviceIsNotHisense()
      ) {
        window.removeEventListener('keydown', this.keyPressHandler, true);
        window.addEventListener('keydown', this.keyPressHandler, true);
      } else {
        document.removeEventListener('keydown', this.keyPressHandler, false);
        document.addEventListener('keydown', this.keyPressHandler, false);
      }
    }

    if (this.refs.action_bar) {
      document.removeEventListener('keydown', this.handleBlueButton, false);
      document.addEventListener(
        settings.blue_button_epg_Persistance,
        this.handleBlueButton,
        false
      );
    }

    const namesButtons = this.getVisibleButtons();

    Object.keys(namesButtons).map(name => {
      const element = document.getElementById(name);
      const func = () => this[name]();
      if (element) {
        if (name !== 'backward' || name !== 'forward') {
          // Se agrega porque al menos en local, se van duplicando los listeners
          // conforme se usan
          this.removeButtonListener(name, 'sn:enter-down');
          element.removeEventListener('sn:enter-down', func);
          element.addEventListener('sn:enter-down', func);

          if (!this.buttonsListeners[name]) {
            this.buttonsListeners[name] = {};
          }

          if (!this.buttonsListeners[name]['sn:enter-down']) {
            this.buttonsListeners[name]['sn:enter-down'] = [];
          }

          this.buttonsListeners[name]['sn:enter-down'].push(func);
        }
      }
    });
  }

  // Se agrega porque al menos en local, se van duplicando los listeners
  // conforme se usan
  removeButtonListener(buttonName, type) {
    if (this.buttonsListeners[buttonName]) {
      if (this.buttonsListeners[buttonName][type]) {
        logger.debug('&&&&&&&&&&&& segundo map 3, 3- se quita listener a ', buttonName);
        if (Utils.isArray(this.buttonsListeners[buttonName][type])) {
          for (let y = 0; y < this.buttonsListeners[buttonName][type].length; y++) {
            let b = document.getElementById(buttonName);
            if (b) {
              b.removeEventListener(type, this.buttonsListeners[buttonName][type][y]);
            }
          }
          this.buttonsListeners[buttonName][type] = [];
        }
      }
    }
  }

  removeListeners() {
    ShowPlayerControlsObserver.unsubscribe(this.show);
    HidePlayerControlsObserver.unsubscribe(this.hide);
    document.removeEventListener('manage_action_bar', this.handleActionBar);
    const buttons = Array.from(document.querySelectorAll('.player-ui-button'));

    buttons.map((button, index) => {
      button.removeEventListener('sn:focused', this.onFocus);
      button.removeEventListener('sn:enter-down', this.show);
      button.removeEventListener('sn:willmove', this.onFocusMove);
    });
    if (this.refs.slider) {
      this.refs.slider.removeEventListener('sn:focused', this.show);
      this.refs.slider.removeEventListener('sn:willmove', this.slide);
    }
    if (this.refs.container) {
      if (
        navigator.userAgent.toLowerCase().indexOf('opera') !== -1 &&
        (navigator.userAgent.toLowerCase().indexOf('netrange') === -1 || navigator.userAgent.toLowerCase().indexOf('netrangemmh') === -1 ) &&
        Utils.deviceIsNotHisense()
      ) {
        window.removeEventListener('keydown', this.keyPressHandler, true);
      } else {
        document.removeEventListener('keydown', this.keyPressHandler, false);
      }
    }

    const namesButtons = this.getVisibleButtons();
    Object.keys(namesButtons).map(name => {
      const element = document.getElementById(name);
      const func = () => this[name]();
      if (element) {
        element.removeEventListener('sn:enter-down', func);
      }
    });
  }

  componentDidMount() {
    this.updateCurrentTimeUI(this.currentTime);
    this.addListeners();
    this.setTimer();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.playFromCard && !EpgPersistence.isEnabled()) {
      this.verifySetAutoHide();
    }
    this.updateCurrentTimeUI(this.currentTime);
    this.setSpriteImage();
    this.skipIntroControl();
    if (Utils.isModalHide()) {
      let currentEventId = Utils.idEventCurrent(
        this.epgInPlayerControl,
        this.currentHorizontalIndex
      );
      logger.debug('FOCUS MINI', currentEventId);
      Utils.isMiniEPGOpen() &&
      window.SpatialNavigation.focus(
        currentEventId || '.epg-event-item-container .focusable'
      );
    }
  }


  setSpriteImage() {
    if (this.areSpritesSupportedOnThisDevice()) {
      let url = '';
      if (this.props.getSpriteImage()) {
        // imageSpriteURL is Empty or selecting a different one from Ficha
        this.imageSpriteURL = this.props.getSpriteImage();
        this.imageSprite.src = this.imageSpriteURL;
      } else {
        if (this.imageSpriteURLnew) url = this.imageSpriteURLnew;
        else url = this.imageSpriteURL;
      }
      if (url && url.includes('SPRITES', 0) && this.imageSprite.src !== url) {
        this.imageSprite.src = url;
        this.imageSpriteURL = url;
        this.proporcion = 0;
      }
    }
    if (this.imageSprite.src) {
      this.imageSprite.onload = () => {
        this.shouldSpriteShow = this.canShowSprites();
      };
    }

  }

  onPlayerStopMedia() {
    this.resetSprites();
  }

  /**
   * Se manda a llamar cuando se hace stop desde el player
   */
  resetSprites() {
    this.imageSprite.src = null;
    // this.imageSprite = null;
    this.imageSpriteURL = null;
    // this.imageSprite = new Image();
    // this.imageSprite.crossOrigin = 'Anonymous';
  }

  componentWillUnmount() {
    this.removeListeners();
    if (this.onLivePauseTimer) clearInterval(this.onLivePauseTimer);
  }

  setChannelInfo(channelInfo) {
    this.timeshiftAllowed = channelInfo.timeshiftAllowed ? channelInfo.timeshiftAllowed : 0;
    if (!channelInfo.fromCoverFlow) {
      if (
        channelInfo &&
        channelInfo.timeshiftAllowed &&
        channelInfo.currentTimeshiftTime === 0
      ) {
        if (!this.state.timeshiftEventInfo) {
          this.currentTime = channelInfo.timeshiftAllowed;
        }

        this.setState({ channelInfo: channelInfo, timeshiftTime: 0 });
      } else {
        if (Utils.isNotNullOrNotUndefined(channelInfo.currentTimeshiftTime)) {
          if (!this.state.timeshiftEventInfo) {
            this.currentTime = channelInfo.currentTimeshiftTime;
          }

          this.setState({ channelInfo, timeshiftTime: channelInfo.currentTimeshiftTime });
        } else {
          this.setState({ channelInfo });
        }
      }
    }
  }

  setTrackInfo(trackInfo){
    this.trackInfo = trackInfo;
    SetLangsLive.set(trackInfo);
  }

  setTimeshiftEventInfo(timeshiftEventInfo) {
    this.switchingBetweenEventTimeshift = false;
    logger.debug('PAU> function setTimeshiftEventInfo > ' + this.switchingBetweenEventTimeshift);
    logger.debug('PAU6> player controls setTimeshiftEventInfo');
    // NOTICE: timeshiftEventInfo could be NULL
    if (timeshiftEventInfo && timeshiftEventInfo.event) {
      this.currentTime = 0;
      this.state.timeshiftTime = 0;
    }
    this.setState({ timeshiftEventInfo });
  }

  saveEpgData(epg, index) {
    this.epgInPlayerControl = epg;
    this.currentHorizontalIndex = index;
  }

  getFastPlaybackContainer() {
    const streamContentType = this.props.streamContentType();

    let cssNB = 'player-ui-controls-trickmode-backward';
    let cssNF = 'player-ui-controls-trickmode-forward';

    if (
      streamContentType === constant.AAF_CONTENT_IS_CATCHUP ||
      streamContentType === constant.AAF_CONTENT_IS_NPVR
    ) {
      cssNB = 'player-ui-controls-trickmode-backward-catchup';
      cssNF = 'player-ui-controls-trickmode-forward-catchup';
    }

    return (
      <div className="player-ui-playback-speed-wrapper">
        <div id="trickmode_backward" className={cssNB} />
        <div id="trickmode_forward" className={cssNF} />
      </div>
    );
  }

  showGuideFromActionBar(e) {
    this.props.handleFullEpg('GUIDE');
  }

  handleBlueButton(e) {
    const event = e.detail;
    const streamContentType = this.props.streamContentType();

    if (streamContentType !== constant.AAF_CONTENT_IS_TV) {
      //FIX solo se debe mostrar el Action Bar en contenidos de TV
      return;
    }

    const isActionBarVisible = e.detail.fromFullEPG ? false : this.state.actionBar.isVisible;

    if (e.detail.fromFullEPG) {
      this.props.hideEpgOutside();
    }

    if (isActionBarVisible || !event) {
      this.setState(prevState => ({
        ...prevState,
        actionBar: {
          ...prevState.ActionBar,
          isVisible: false
        }
      }));
      if (event && typeof event.cb === 'function') {
        event.cb();
      }
    } else {
      const channel = new ChannelSingleton().getChannelByGroupIdNow(event.group_id);

      this.setState(
        prevState => ({
          ...prevState,
          actionBar: {
            ...prevState.ActionBar,
            isVisible: !isActionBarVisible,
            title: event.name ? event.name : '',
            channel: channel.channel_number ? channel.channel_number : '',
            event
          }
        }),
        () => {
          if (!isActionBarVisible) {
            this.show();
            setTimeout(() => {
              window.SpatialNavigation.focus(
                '.action-bar.container .action-bar-wrapper:first-child a'
              );
            }, 500);
          }
        }
      );
    }
  }

  setTrueLetsPlayCatchup = () => (this.letsPlayCatchup = true);

  render() {

    const backgroundReplay = {
      background: getBackgroundReplay()
    };

    if (!this.props.enable) {
      if (
        navigator.userAgent.toLowerCase().indexOf('opera') !== -1 &&
        (navigator.userAgent.toLowerCase().indexOf('netrange') === -1 || navigator.userAgent.toLowerCase().indexOf('netrangemmh') === -1 ) &&
        Utils.deviceIsNotHisense()
      ) {
        window.removeEventListener('keydown', this.keyPressHandler, true);
      } else {
        document.removeEventListener('keydown', this.keyPressHandler, false);
      }
      return null;
    }

    const visibleClass = this.props.visible ? '' : 'hide-down';
    const typeClass = `player-ui-${this.props.type}`;
    const buttons = this.getVisibleButtons();
    const ifYellow = this.enableButton('yellow');

    const checkStatusEpg = {
      checkStatusEPG: this.props.checkStatusEPG,
      checkStatusCoverFlowCH: this.props.checkStatusCoverFlowCH
    };

    const flowPressDown = this.disableTS ? '.player-secondary-button' : '.player-main-button';
    const streamContentType = this.props.streamContentType();
    if (streamContentType == null && !this.letsPlayCatchup && !this.props.livePlayingAsPip()) {
      this.letsPlayCatchup = true;
    }
    const initialClassName =
      streamContentType === constant.AAF_CONTENT_IS_TV ||
      (!streamContentType && !this.letsPlayCatchup)
        ? ''
        : 'hide-controls';
    if (this.letsPlayCatchup) {
      this.letsPlayCatchup = false;
    }

    // Se agrega validación de props type === live para que no aparezcan las barritas del jony en las transiciones (horizontOne y horizontTwo, por ejemplo en el flujo playing live > miniepg con a evento pasado > botón azúl > clic en reiniciar evento >>> pasa de live a catchup y en el inter se ven las dos barritas)
    const isLiveOrStartover =
      (streamContentType === constant.AAF_CONTENT_IS_TV ||
        streamContentType === constant.AAF_CONTENT_IS_STARTOVER) &&
      this.props.type === 'live';

    const supportTrickMode =
      this.isFastRewindEnable() &&
      (streamContentType === constant.AAF_CONTENT_IS_CATCHUP ||
        streamContentType === constant.AAF_CONTENT_IS_STARTOVER ||
        streamContentType === constant.AAF_CONTENT_IS_NPVR);

    let uiControlsContainerClass = 'player-ui-controls-container';
    let fastPlaybackContainer = '';

    if (supportTrickMode) {
      uiControlsContainerClass = 'player-ui-controls-container-trickmode';
      fastPlaybackContainer = this.getFastPlaybackContainer();
    }

    return (
      <div>
        {
          <div
            className={`player-ui-container-skip player-ui-controls skip-intro-up`}
            ref="skipIntro"
          >
            {this.getSkipIntroButton()}
          </div>
        }
        <div
          id="player-ui-container"
          className={`player-ui-container ${visibleClass} ${typeClass} show-mini-epg ${
            this.isVisible ? '' : this.hasEpgErrorOnLive() ? 'hide-controls' : ''
            } ${initialClassName}
                    `}
          ref="container"
        >
          <div className="" ref="channelNumber" />
          <div
            className={`player-ui-wrapper ${
              this.hasEpgErrorOnLive()
                ? 'hide'
                : this.state.actionBar.isVisible
                ? 'actionBar'
                : ''
              }`}
          >
            <div className="player-ui-epg">
              {EpgPersistence.isEnabled() ? (
                <Mini
                  hideControls = {this.hideControls}
                  hideActionBar = {this.hideActionBarAfterZapping}
                  setCurrentEventInPlayerControls={event => {
                    this.currentEvent = event;
                  }}
                  onUpdateEpg={this.props.onUpdateEpg}
                  goToCard={this.props.goToCard}
                  onPressYellowButton={this.toggleControls}
                  enableButton={this.enableButton}
                  changeLang={this.props.changeLang}
                  streamType={this.props.streamType}
                  getContentStreamType = {this.props.streamContentType}
                />
              ) : null}
              {!EpgPersistence.isEnabled() &&
              this.isLive() &&
              (this.state.channelInfo.id || this.props.epgGroupId) ? (
                <MiniEpg
                  onUpdateEpg={this.props.onUpdateEpg}
                  groupId={this.state.channelInfo.id || this.props.epgGroupId}
                  handleFullEpg={e => this.props.handleFullEpg('GUIDE')}
                  onPressYellowButton={this.toggleControls}
                  isOpen={!this.state.showControls}
                  setMetricsEvent={this.props.setMetricsEvent}
                  onGetCurrentData={eventCurrent => {
                    if (
                      store.getState().epg.place === 'ChangeWithNumber' ||
                      store.getState().epg.place === 'FullEPG'
                    ) {
                      this.show();
                      store.dispatch(navigateFrom(''));
                    }
                    const lastEventGroup =
                      this.currentEvent && this.currentEvent.groupId;
                    this.currentEvent = eventCurrent;
                    if (
                      eventCurrent &&
                      eventCurrent.groupId !== lastEventGroup
                    ) {
                    }
                  }}
                  onGetCurrentEvent={eventCurrentOriginal => {
                    this.currentEventOriginal = eventCurrentOriginal;
                  }}
                  show={this.show}
                  hideListeners={this.onHideListeners}
                  goToCard={this.props.goToCard}
                  enableButton={this.enableButton}
                  hideEpgOutside={this.props.hideEpgOutside}
                  onChangingChannel={this.props.onChangingChannel}
                  changeCurrentGroupId={this.props.changeCurrentGroupId}
                  fromProps={this.props.fromProps}
                  setFromProps={this.props.setFromProps}
                  saveEpgData={this.saveEpgData}
                  enabledControlsTS={this.enabledControlsTS}
                  {...checkStatusEpg}
                />
              ) : null}
            </div>
            <div className={`player-ui-controls`}>
              <div className="player-ui-time-line">
                <div className="player-ui-current-time" ref="currentTime">
                  {this.getCurrentTimeAsString()}
                </div>
                {EventTimeshift.isEnabled() && isLiveOrStartover ? (
                  <div
                    className="horizont-one"
                    ref="horizontOne"
                    style={
                      Utils.getLiveBarBackgroundColor().backgroundColor
                        ? {
                          backgroundColor: Utils.getLiveBarBackgroundColor()
                            .backgroundColor
                        }
                        : {}
                    }
                  />
                ) : null}
                <div className="player-ui-progress-bar-container">
                  <div
                    id="playerUIProgressBar"
                    className="player-ui-progress-bar"
                  >
                    <div id="startovericon" className="bar-icon-startover" style={backgroundReplay}>
                      <img src={Asset.get('player_controls_replay_icon')} />
                    </div>
                    <div
                      id="player-ui-progress-load"
                      ref="progressLoad"
                      className="player-ui-progress-bar-load"
                    />
                    <canvas
                      id="player-ui-progress-bar-sprite"
                      ref="sprite"
                    />
                    <div
                      id="player-ui-current-time-sprite"
                      className="player-ui-current-time-sprite"
                      ref="currentTimeSprite"
                    >
                      {this.getCurrentTimeAsString()}
                    </div>
                    <div
                      id="player-ui-progress-bar"
                      ref="progressBar"
                      className="player-ui-progress-bar-time-tick"
                      style={
                        Utils.getLiveBarBackgroundColor().backgroundColor
                          ? {
                            backgroundColor: Utils.getLiveBarBackgroundColor()
                              .backgroundColor
                          }
                          : {}
                      }
                    >
                      <a
                        id="player-ui-progress-bar-ball"
                        href="javascript:void(0)"
                        ref="slider"
                        className="player-ui-progress-bar-ball focusable"
                        data-sn-down={flowPressDown}
                      />
                    </div>
                    {EventTimeshift.isEnabled() ? (
                      <div
                        id="player-ui-progress-bar"
                        ref="progressBarOpacity"
                      />
                    ) : null}
                  </div>
                </div>
                {EventTimeshift.isEnabled() && isLiveOrStartover ? (
                  <div
                    className="horizont-two"
                    ref="horizontTwo"
                    style={
                      Utils.getLiveBarBackgroundColor().backgroundColor
                        ? {
                          backgroundColor: Utils.getLiveBarBackgroundColor()
                            .backgroundColor
                        }
                        : {}
                    }
                  />
                ) : null}
                <div className="player-ui-duration" ref="duration">
                  {this.getDurationAsString()}
                </div>
              </div>

              <div className={`${uiControlsContainerClass}`}>
                {Object.keys(buttons).map((name, index) => buttons[name])}
              </div>
              {/* fastPlaybackContainer */}
            </div>
            {this.isLive() ? (
               <ul className="color-codes">
               {this.state.showControls ? null : ifYellow &&
               !this.enabledControlsTS() &&
               config_remote_control &&
               Utils.getShowHelperButtonsMiniEpg().enable ? (
                 <li className="color-code-item ctrls" style={{ float: 'left' }}>
                   <span className="color-ball yellow" />
                   <span>
                           <img
                             src={Asset.get('logo_controles_live')}
                             alt="logo_controles_live"
                           />
                         </span>
                 </li>
               ) : null}
               <li className="color-code-item">
                 {!config_remote_control ? (
                   <span>
                                           Manten presionado <span className="clv-btn">OK</span>{' '}
                     para obtener los controles de reproducción
                                       </span>
                 ) : (
                   ifYellow &&
                   !this.enabledControlsTS() && (
                     <div>
                       <span className="color-ball yellow" />
                       {Translator.get(
                         'show_mini_epg',
                         'Mini-guía en pantalla'
                       )}
                     </div>
                   )
                 )}
                 {/*<span className="color-ball yellow" /> {Translator.get('play_controls', 'Mini-guia en pantalla')}*/}
               </li>
               {this.enableButton('blue') &&
               this.state.showBlueButton &&
               streamContentType !== constant.AAF_CONTENT_IS_STARTOVER && (
                 <li className="color-code-item">
                   {!config_remote_control ? null : (
                     <li className="color-code-item">
                       <span className="color-ball blue" />{' '}
                       {Translator.get(
                         'epg_options',
                         'Opciones de programa'
                       )}
                     </li>
                   )}
                 </li>
               )}
               <li className="color-code-item">
                 {!config_remote_control ? null : (
                   <li className="color-code-item">
                     <span className="color-ball red" />{' '}
                     {Translator.get('buscar', 'Buscar')}
                   </li>
                 )}
               </li>
               {/*
                  <li className="color-code-item">
                  <span className="color-ball blue"/> {Translator.get('more_info', 'Más Info')}
                  </li>
                  */}
             </ul>



            ) : null}
          </div>
          <ActionBar
            ref="action_bar"
            visible={this.state.actionBar.isVisible}
            channel={this.state.actionBar.channel}
            title={this.state.actionBar.title}
            event={this.state.actionBar.event}
            showGuide={this.showGuideFromActionBar}
            hideMe={this.hideActionBar}
            viewFromStart={this.back}
            showLangModal={this.showLangModal}
            hideAction={this.hideActionBar}
            streamType={this.getStreamType}
          />
        </div>

      </div>
    );
  }
}

PlayerControlsLegacy.propTypes = {
  duration: PropTypes.number,
  currentTime: PropTypes.number,
  autoPlay: PropTypes.bool,
  enable: PropTypes.bool,
  visible: PropTypes.bool,
  autoHide: PropTypes.bool,
  type: PropTypes.oneOf(['vod', 'default', 'live', 'serie', 'audio', 'radio']),
  buttons: PropTypes.shape({
    back: PropTypes.element,
    record: PropTypes.element,
    replay: PropTypes.element,
    fastBackward: PropTypes.element,
    stepBackward: PropTypes.element,
    backward: PropTypes.element,
    play: PropTypes.element,
    pause: PropTypes.element,
    forward: PropTypes.element,
    stepForward: PropTypes.element,
    fastForward: PropTypes.element,
    next: PropTypes.element,
    seasons: PropTypes.element
  }),
  play: PropTypes.func,
  pause: PropTypes.func,
  backward: PropTypes.func,
  stepBackward: PropTypes.func,
  fastBackward: PropTypes.func,
  forward: PropTypes.func,
  stepForward: PropTypes.func,
  fastForward: PropTypes.func,
  replay: PropTypes.func,
  back: PropTypes.func,
  next: PropTypes.func,
  record: PropTypes.func,
  changeLang: PropTypes.func
};

PlayerControlsLegacy.defaultProps = {
  duration: 0,
  currentTime: 0,
  autoPlay: false,
  enable: true,
  visible: true,
  autoHide: false,
  type: 'live',
  buttons: {},
  play: () => {},
  pause: () => {},
  backward: () => {},
  stepBackward: () => {},
  fastBackward: () => {},
  forward: () => {},
  stepForward: () => {},
  fastForward: () => {},
  replay: () => {},
  back: () => {},
  next: () => {},
  record: () => {},
  changeLang: () => {}
};
/*
 PlayerControlsLegacy.contextTypes = {
 router: React.PropTypes.object.isRequired
 };
 */

export const playerControlsIsVisible = () => PlayerControlsLegacy.isVisible;
export default PlayerControlsLegacy;



// WEBPACK FOOTER //
// ./src/components/PlayerControls/PlayerControls.js